import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./twilio.scss";

import { useTheme } from "@emotion/react";
import { useLocation, useNavigate } from "react-router-dom";
import { BsStarFill } from "react-icons/bs";
import { BiStar } from "react-icons/bi";
import CameraAlertImg from "../../media/images/CameraAlertImg.png";
import logo from "../../icons/photos/chillLogo.png";


import { Button, Col, Modal, Spinner } from "react-bootstrap";
import InputField from "../../jsx/components/fields/inputField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import TextArea from "../../jsx/components/fields/textArea";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { userById } from "../../service/api/user/userById";
import {
  setLoaderTime,
  setNotificationCount,
  setUserDetails,
} from "../../feature/userData/userData";
import { saveRating } from "../../service/api/user/saveRating";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { btnVerify, hintEnterValidationCode, lblFirstName, passwordLengthText, validEmail_OR_MobileNumberText } from "../../dataBaseFile/label";
import { emailValidation, noSpaceOnChange, phoneValidation } from "../../validations/validation";
import shareServiceRequest from "../../service/api/ticket/shareServiceRequest";
import { FaShare } from "react-icons/fa";
import updateTicketStatus from "../../service/api/ticket/updateTicketStatus";
import acceptServiceImg from '../../media/images/proDashboardAssets/acceptServiceImg.png'
import { ticketDetailsApi } from "../../service/api/ticket/getTicketDetails";
import { getPaymentConfigApi } from "../../service/api/paymentGateway/getPaymentConfig";
import updateTicketSummaryApi from "../../service/api/ticket/updateTicketSummary";
import { createUpdateProjectApi } from "../../service/api/ticket/createUpdateProject";
import { callNoteDetails } from "../../service/api/callHistory/callNoteDetails";
import { getPurchaseList } from "../../service/api/ticket/getPurchaseList";
import googleSourcingInfoFromDeviceModelApi from "../../service/api/object/googleSourcingInfoFromDeviceModel";
import emptyListImg from '../../media/images/servicesAssets/emptyListImg.png'
import { urlPattern } from "../../validations/validation";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import searchImg from '../../media/images/servicesAssets/searchImg.png'
import { saveCallDurationApi } from "../../service/api/video/saveCallDuration";
import guestHomeownerForumApi from "../../service/api/guestUsers/guestHomeownerForum";
import { confirmPasswordValidation, firstNameValidation, passwordValidation } from "../../functions/validations";
import { enterFirstName, errEmptyEmailOrPhone, validFirstName, validPassword } from "../../dataBaseFile/error";
import { signUp } from "../../service/api/user/signUp";
import { activateUser } from "../../service/api/user/activationCode";

const CallRating = ({ onClose, joinCallRes, handleUpdateForEstimationReport }) => {
  const { permissionArr, isCheckInCall, userName } = useSelector((state) => state.user);
  const { authorized } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rating, setRating] = useState(5);

  const [hover, setHover] = useState(0);
  const [appLink, setAppLink] = useState(
    "https://chilll.page.link/inviteFriend"
  );

  const permissionArray = permissionArr[0] || []

  const [ratingValue, setRatingValue] = useState(5);
  const [jobStatus, setJobStatus] = useState(2);
  const [changeJobStatusLoading, setChangeJobStatusLoading] = useState(false)
  const [appLinkLoading, setAppLinkLoading] = useState(false);

  const [isEstimationsCall, setIsEstimationsCall] = useState(0);
  const [estimationCallTabs, setEstimationCallTabs] = useState(1);
  const [proRecommendedSolution, setProRecommendedSolution] = useState(0);

  const [customerEstimatedCostMin, setCustomerEstimatedCostMin] = useState(``);
  const [customerEstimatedCostMax, setCustomerEstimatedCostMax] = useState(``);
  const [localProSectionDateTime, setLocalProSectionDateTime] = useState('1');
  const [currentDateLocalPro, setCurrentDateLocalPro] = useState('');
  const [currentTimeLocalPro, setCurrentTimeLocalPro] = useState('');

  const [termsAndConditions, setTermsAndConditions] = useState(localStorage.getItem('projectId') ? true : false);
  const [termsAndConditionsErr, setTermsAndConditionsErr] = useState(false);

  const [updateTicketSummaryLoading, setUpdateTicketSummaryLoading] = useState(false);

  const [serviceDetailsObj, setServiceDetailsObj] = useState({});
  const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});

  const [paymentGatewayFlag, setPaymentGatewayFlag] = useState(0);
  const [callChargeAmount, setCallChargeAmount] = useState(0);
  const [callDurationTimeLimit, setCallDurationTimeLimit] = useState(0);
  const [callChargeDescription, setCallChargeDescription] = useState("");

  const [createUpdateProjectLoading, setCreateUpdateProjectLoading] = useState(false);

  const [projectId, setProjectId] = useState('');

  const [proGivingEstimations, setProGivingEstimations] = useState(isCheckInCall);
  const [isProGivenEstimations, setIsProGivenEstimations] = useState(false);

  const [tabsForEstimationsModal, setTabsForEstimationsModal] = useState(1);

  const [estimateCost, setEstimateCost] = useState(`0`);
  const [estimateDisposal, setEstimateDisposal] = useState(`0`);
  const [estimateLabor, setEstimateLabor] = useState(`0`);
  const [estimatedCostByPro, setEstimatedCostByPro] = useState(`0`);

  const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);
  const [elements, setElements] = useState([]);
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [productType, setProductType] = useState('');
  const [brandName, setBrandName] = useState('');
  const [modelNumber, setModelNumber] = useState('');
  const [isProductTypeErr, setIsProductTypeErr] = useState(false);
  const [isBrandNameErr, setIsBrandNameErr] = useState(false);
  const [specificPart, setSpecificPart] = useState('');
  const [sourcingInfoLoading, setSourcingInfoLoading] = useState(false);
  const [sourcingManualsArr, setSourcingManualsArr] = useState([]);
  const [sourcingInfoArr, setSourcingInfoArr] = useState([]);
  const [sourcingShoppingArr, setSourcingShoppingArr] = useState([]);
  const [supportsArr, setSupportsArr] = useState([]);
  const [tabsPartsManuals, setTabsPartsManuals] = useState('1');
  const [sourcingInfoTabs, setSourcingInfoTabs] = useState(1);
  const rows = elements;

  const [totalCost, setTotalCost] = useState(0);
  const [purchaseLoading, setPurchaseLoading] = useState(false);

  const [attachImageIndex, setAttachImageIndex] = useState(0);
  const shoppingItemLinkWidthRef = useRef();
  const navRef = useRef(null);

  const [proDiagnosis, setProDiagnosis] = useState("");
  const [proDiagnosisErr, setProDiagnosisErr] = useState(false);
  const [proRecommendedSolutionErr, setProRecommendedSolutionErr] = useState(false);
  const [proEstimatedCostMin, setProEstimatedCostMin] = useState(``);
  const [proEstimatedCostMax, setProEstimatedCostMax] = useState(``);

  const [firstName, setFirstName] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [errorFirstNameMsg, setErrorFirstNameMsg] = useState("");

  const [messageText, setMessageText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [submitError, setSubmitError] = useState("");

  const [loginErrorMsg, setLoginErrorMsg] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const baseURI = process.env.REACT_APP_MY_ENV.replace(/^https:\/\//, "");

  // Signup flow for the customer
  const [isPassword, setIsPassword] = useState(false);
  const [password, setPassword] = useState("Chilll@123");
  const [passwordConfirm, setPasswordConfirm] = useState("Chilll@123");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);
  const [loaderActive, setLoaderActive] = useState(false);
  const [role, setRole] = useState(2);
  const [zipCode, setZipCode] = useState("");

  const [recievedCodeValue, setRecievedCodeValue] = useState("");
  const [isCodeError, setIsCodeError] = useState(false);

  const [stepsForGuestHomeOwner, setStepsForGuestHomeOwner] = useState(1);

  const handleZipCode = (e) => {
    setZipCode(e.target.value.replace(/\D/g, ''))
  }

  function handleValidateCode(e) {
    setIsCodeError(false);
    setRecievedCodeValue(e.target.value);
  }

  const handleFirstName = (e) => {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  };

  const handleMessageText = (e) => {
    setMessageText(e.target.value);
  }

  const handleCustomerEstimatedCostMin = (e) => {
    setCustomerEstimatedCostMin(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };


  const handleCustomerEstimatedCostMax = (e) => {
    setCustomerEstimatedCostMax(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  useEffect(() => {
    if (+customerEstimatedCostMin > +customerEstimatedCostMax) {
      setCustomerEstimatedCostMax((+customerEstimatedCostMin * 1.2).toFixed(2));
    }
  }, [customerEstimatedCostMin])

  // Get service details 
  const getServiceDetailsFn = (isSaveDuration = false) => {
    setUpdateTicketSummaryLoading(true);
    let details = {
      ticket_id_ids: localStorage.getItem("ticket_id"),
    };
    dispatch(
      ticketDetailsApi(details, (res) => {
        // console.log(res);
        setUpdateTicketSummaryLoading(false);

        setServiceDetailsObj(res?.data);

        if (isProGivenEstimations || isSaveDuration) {
          saveCallDurationForEstimationsCall(res?.data?.remaining_time_in_sec);
        }

        console.log("res?.data?.summary_meta_data", res?.data?.summary_meta_data)

        if (res?.data?.summary_meta_data) {

          // debugger;
          // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
          // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

          const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

          let finalObject = {};

          // if(!Object.keys(finalObjectTwo).length > 0) {
          if (typeof (finalObjectTwo) === 'string') {
            finalObject = JSON.parse(finalObjectTwo);
          }

          console.log(finalObject, "finalObject");
          console.log(finalObjectTwo, "finalObjectTwo");

          if (Object.keys(finalObject).length > 0) {

            setServiceSummaryMetaData(finalObject);
            setProRecommendedSolution(finalObject?.pro_check_info?.pro_recommended_solution || 0);
            setIsEstimationsCall(finalObject?.is_estimations_call || 0);
          } else if (Object.keys(finalObjectTwo).length > 0) {
            setServiceSummaryMetaData(finalObjectTwo);
            setProRecommendedSolution(finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);
            setIsEstimationsCall(finalObjectTwo?.is_estimations_call || 0);
          } else {
            setServiceSummaryMetaData({});
          }
        }
      }, (res) => {
        setUpdateTicketSummaryLoading(false);

        setResponceMsg(res.data.message);
        setToasterType("error");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

      })
    );
  };

  const getPaymentConfigFn = () => {
    let details = {};
    dispatch(
      getPaymentConfigApi(
        details,
        (res) => {
          // console.log(res.data.data)
          // console.log(res?.data?.data)
          setPaymentGatewayFlag(
            res?.data?.data?.purchase?.payment_gateway_flag
          );
          setCallChargeAmount(
            res?.data?.data?.purchase?.call_charge_amount_in_cents_int / 100
          );
          setCallDurationTimeLimit(
            res?.data?.data?.purchase?.call_duration_time_limit_in_sec / 60
          );
          setCallChargeDescription(
            res?.data?.data?.purchase?.call_charge_description_chr
          );
        },
        (res) => {
          // console.log(res.data.data);
        }
      )
    );
  };

  const handleSetCurrentDateAndTime = () => {
    // Get the current date and time
    const now = new Date();
    const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

    // Set the time one hour ahead
    now.setHours(now.getHours() + 1);

    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Adjust minutes to the nearest 30-minute slot
    minutes = minutes < 30 ? 0 : 30;

    // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
    if (minutes === 0 && now.getMinutes() >= 30) {
      hours += 1;
    }

    // Ensure two-digit formatting for hours and minutes
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes === 0 ? `00` : `30`;

    const time = `${hours}:${minutes}`;

    // Update the state
    setCurrentTimeLocalPro(time);
    setCurrentDateLocalPro(date);
  };

  // Detect platform (iOS or Android)
  const userAgent = navigator.userAgent;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("roomId")) {
      const roomId = urlParams.get("roomId");
      localStorage.setItem("roomCode", roomId);
    }
  }, []);

  const handleBack = () => {
    navigate("/dashboard");
  };

  // useEffect(()=>{

  // }, [handleToaster])

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("roomId")) {
      const roomId = urlParams.get("roomId");
      localStorage.setItem("roomCode", roomId);
    }

    if (authorized) {
      let user = {
        user_id_ids: localStorage.getItem("user_id") || "",
        role_id_int: localStorage.getItem("roleId"),
        user_impersonate_flag: 0,
      };
      dispatch(
        userById(user, (res) => {
          dispatch(setUserDetails(res.data.data));
          dispatch(setLoaderTime(res.data));
          // console.log(`${res.data.data.is_active_ysn} res.data.data.is_active_ysn`)
          localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
        })
      );

      if (permissionArray.includes("CONNECT TO PRO")) {
        getPaymentConfigFn();
      }

      getServiceDetailsFn();
      handleSetCurrentDateAndTime();
    }
  }, []);

  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  function submitFeedback(e) {
    e?.preventDefault();
    if (rating > 0) {
      setIsLoading(true)
      var data = {
        user_id_ids: localStorage.getItem("remoteUserId") || "",
        call_log_id_ids: localStorage.getItem("call_log_id"),
        rating_value_int: rating,
        comment_chr: feedbackMessage,
        given_by_name_chr: "user",
      };
      dispatch(
        saveRating(
          data,
          (res) => {

            setRating(0);
            setFeedbackMessage("");
            setIsLoading(false)
            setResponceMsg(res.data.message);
            setToasterType("success");

            setChangeJobStatusLoading(false);

            navigate("/dashboard");
            localStorage.setItem("isDisconnectedCall", JSON.stringify(true))

            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            //   navigate("/dashboard");
            // }, 5000);

            // window.location.reload();
          },
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("error");
            setIsLoading(false)
            setChangeJobStatusLoading(false);
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else {
    }
  }

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `You talked ${remainingSeconds} seconds`;
    } else if (remainingSeconds === 0) {
      return `You talked ${minutes} min`;
    } else {
      return `You talked ${minutes} min and ${remainingSeconds} seconds`;
    }
  }

  const handleSignUpGuest = (e) => {
    e?.preventDefault();
    navigate("/signUpCustomer");
  }

  // Share Service Request functions start here ---------
  const [showShareService, setShowShareService] = useState(false);
  const handleShowShareService = () => setShowShareService(true);
  const handleCloseShareService = () => {
    setShowShareService(false);
    setEmailPhoneValue("");
    setCodeValue();
    setIsEmailPhoneVal(false);
  }

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState(1);
  const [isPhone, setIsPhone] = useState(false);
  const [shareLoading, setShareLoading] = useState(false);

  const handleShareService = (e, isHomeOwnerFlag = false) => {
    e.preventDefault();
    if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
      setShareLoading(true);
      if (isPhone) {
        const data = new FormData();
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"))
        data.append("is_sharable_ysn", 1);
        data.append("email_chr", "");
        data.append("phone_code_id_int", parseInt(codeValue) || 1);
        data.append("phone_number_int", emailPhoneValue);
        isHomeOwnerFlag && data.append("is_guest_homeowner_flag", 1);
        isHomeOwnerFlag && data.append("guest_homeowner_name", firstName);

        dispatch(
          shareServiceRequest(data, (res) => {
            setShareLoading(false)
            setResponceMsg(res.data.message)
            setToasterType("success")

            handleCloseShareService();

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);
          }, (err) => {
            setShareLoading(false)
            setResponceMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          })
        );
      } else if (!isPhone) {

        const data = new FormData();
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"))
        data.append("is_sharable_ysn", 1);
        data.append("email_chr", emailPhoneValue);
        // data.append("phone_code_id_int", parseInt(codeValue) || 1);
        // data.append("phone_number_int", emailPhoneValue);
        isHomeOwnerFlag && data.append("is_guest_homeowner_flag", 1);
        isHomeOwnerFlag && data.append("guest_homeowner_name", firstName);

        dispatch(
          shareServiceRequest(data, (res) => {
            setShareLoading(false)
            setResponceMsg(res.data.message)
            setToasterType("success")

            handleCloseShareService();

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);
          }, (err) => {
            setShareLoading(false)
            setResponceMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          })
        );
      }
    } else {
      setIsEmailPhoneVal(true);
    }
  };

  const handleEmailPhone = (e) => {
    setIsEmailPhoneVal(false);

    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
  };
  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);
  };

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  function handleEmailPhoneBlur() {
    if (isPhone) {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    } else {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    }
  }

  useEffect(() => {
    inviteView()
  }, [])

  function inviteView() {


    var request_url = window.location.href
    const ticketId = localStorage.getItem('ticket_id');
    if (ticketId) {
      const urlObj = new URL(request_url);
      urlObj.searchParams.set('ticketId', ticketId);  // Add the ticketId parameter
      request_url = urlObj.toString();

    } else {
      console.error('No ticketId found in local storage.');

    }



    // Encode the entire request URL
    const encodedRequestUrl = encodeURIComponent(request_url);

    // Construct app link based on platform
    const appLink = isAndroid
      ? `${baseURI}://deeplink?request_url=${encodedRequestUrl}` // Android app deep link
      : `${baseURI}://deeplink?request_url=${encodedRequestUrl}`; // iOS app deep link

    // Set the app link
    setAppLink(appLink);


    // Old firebase dynamic code
    // var Name = "Unknown OS";
    // const url = 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyDcF8ay48oU_Dn_u9CziCz7dm7EYEgzkb0'
    // const payload = {
    //   "dynamicLinkInfo": {
    //     "domainUriPrefix": "chilll.page.link",
    //     "link": request_url,
    //     // "link":'https://app.chilll.com/app/?roomId={room_id}&page=video',
    //     "androidInfo": {
    //       "androidPackageName": "com.chilll.app"
    //     },
    //     "iosInfo": {
    //       // "iosBundleId": "com.chilll.app",
    //       "iosBundleId": `${process.env.REACT_APP_DEEPLINK_IOS_ID}`,
    //       "iosAppStoreId": "1621747291"
    //     },
    //     "navigationInfo": {
    //       "enableForcedRedirect": 1,
    //     },
    //   }
    // }
    // const otherPram = {
    //   "headers": {
    //     "content-type": "application/json; charset=UTF-8"
    //   },
    //   "body": JSON.stringify(payload),
    //   "method": "POST"
    // }



    // fetch(url, otherPram)
    //   .then(data => { return data.json() })
    //   .then(res => {
    //     console.log(res["shortLink"], "link", res)

    //     setAppLink(res["shortLink"])

    //   })
    //   .catch(error => console.log(error))


  }
  // Share Service Request functions ends here ---------

  const handleChangeJobStatusFn = (e) => {
    setChangeJobStatusLoading(true);
    e?.preventDefault();


    let formData = new FormData();
    formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    formData.append(
      "ticket_status_ysn",
      jobStatus == 0 ? 0 :
        jobStatus == 1 ? 1 :
          jobStatus == 4 ? 4 :
            jobStatus == 5 ? 5 :
              jobStatus == 7 ? 7 : ''
    );

    // if (isReqRefund) {
    //   raiseRefundFn();
    // }

    dispatch(updateTicketStatus(formData, (res) => {
      // console.log(res)
      setResponceMsg(res.data.message);
      // setChangeJobStatusLoading(false);

      // navigate("/dashboard");

      if (jobStatus == 0 || jobStatus == 4) {
        submitFeedback(e);
      }

      // particularTicketDetails();

      // handleCloseChangeJobStatusModal();

      setToasterType("success")

      // setHandleToaster(true);
      // setTimeout(() => {
      //     setHandleToaster(false);
      // }, 11000);

    }), (res) => {
      console.log(res);
      setResponceMsg(res.data.message);
      setToasterType("error");
      setChangeJobStatusLoading(false);

      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 11000);
    })
  }

  const openInApp = (e) => {
    // Attempt to open the app link
    e?.preventDefault(); // Prevent default anchor behavior

    setAppLinkLoading(true);

    window.location.href = appLink; // Open the app link


    // Set a timeout to redirect to app stores if the app doesn't open (app not installed)
    const timeout = setTimeout(() => {

      // If app doesn't open, redirect to the Play Store or App Store
      if (isAndroid) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.chilll.app";  // Redirect to Play Store if app not installed
      } else if (isIOS) {
        // window.location.href = "https://apps.apple.com/us/app/chilll/id1621747291";  // Redirect to App Store if app not installed
        // window.location.href = "https://apps.apple.com/us/app/apple-store/id1621747291";
        window.open("https://apps.apple.com/us/app/chilll/id1621747291", "_blank");
      } else {
        window.location.href = "https://play.google.com/store/apps/details?id=com.chilll.app";
      }
    }, 1500);  // 1.5 second timeout to check if app opens

    const id = setTimeout(() => {
      setAppLinkLoading(false);
      // isAndroid && alert('Something went wrong, please try after some time.');
    }, 4000);

    // clearTimeout(timeout); // Clear the timeout if the app is opened
  };

  // Format the price to USD 
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  useEffect(() => {
    setProRecommendedSolutionErr(false);
  }, [proRecommendedSolution])

  // Update service summary
  const handleUpdateTicketSummary = (e) => {
    e?.preventDefault();

    setIsProGivenEstimations(true);

    if (localStorage?.getItem('serviceDetails')) {
      localStorage?.removeItem('serviceDetails');
    }
    localStorage?.removeItem('proDiagnosisLocal');
    if (localStorage?.getItem('proRecommendedSolutionLocal')) {
      localStorage?.removeItem('proRecommendedSolutionLocal');
    }

    const safeNum = (val) => isNaN(parseFloat(val)) ? 0 : parseFloat(val);

    if (!proDiagnosis.trim()) {
      setProDiagnosisErr(true);
    }

    if (!proRecommendedSolution) {
      setProRecommendedSolutionErr(true);
    }

    if (proDiagnosis && proRecommendedSolution) {
      let summary_meta_data = {
        recognized_image_summary: serviceSummaryMetaData?.recognized_image_summary || '',
        recognized_estimation_summary: serviceSummaryMetaData?.recognized_estimation_summary || '',
        recognized_repair_and_install_summary: serviceSummaryMetaData?.recognized_repair_and_install_summary || '',
        estimate_costing: {
          cost: safeNum(estimateCost),
          disposal_cost: safeNum(estimateDisposal),
          labor_cost: safeNum(estimateLabor),
          total_range: safeNum(estimateCost) + safeNum(estimateDisposal) + safeNum(estimateLabor),
        },
        repair_install_costing: {
          estimated_cost_by_pro: safeNum(estimatedCostByPro),
        },
        pro_check_info: {
          pro_diagnosis: proDiagnosis,
          pro_estimated_cost_min: safeNum(proEstimatedCostMin),
          pro_estimated_cost_max: safeNum(proEstimatedCostMax),
          pro_recommended_solution: proRecommendedSolution,
        },
        is_estimations_call: 0,
        is_recommendation_updated_by_cust: 0,
      }

      setUpdateTicketSummaryLoading(true);

      // setProductManualFlag(val);

      let formData = new FormData();

      formData.append("ticket_id", localStorage.getItem("ticket_id"));
      formData.append("summary", JSON.stringify(summary_meta_data));


      dispatch(
        updateTicketSummaryApi(
          formData,
          (res) => {
            // dispatch(setIsCheckInCall(true));


            getServiceDetailsFn(true);

            handleUpdateForEstimationReport();

            setProGivingEstimations(false);

            // saveCallDurationForEstimationsCall();
            // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
            // console.log(res?.data?.data?.manual, "here");

            // Real time update service estimation and installation data on customer side
            // const [localValue] = [...room.localParticipant.dataTracks.values()];
            // localValue.track.send("parts_manual");

            setResponceMsg(res.data.message);
            setToasterType("success");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

            // setTimeout(() => {
            //   setUpdateTicketSummaryLoading(false);
            //   setProCheckInfoModalConfirmTrigger(false);
            //   handleLogout();
            // }, 2000)
          },
          (res) => {
            console.log(res);
            setUpdateTicketSummaryLoading(false);

            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  }

  function saveCallDurationForEstimationsCall(remainingTime = 0) {
    const data = new FormData()
    // data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("user_id_ids", joinCallRes?.remote_user_id || "");


    data.append("call_log_id_ids", joinCallRes?.call_log_id_ids);
    data.append("joinee_name_chr", userName);
    // data.append("call_duration_in_second", ((totalCallTimeRedux / 1000)));

    data.append("call_duration_in_second", (remainingTime || serviceDetailsObj?.remaining_time_in_sec));

    dispatch(saveCallDurationApi(data, (res) => {


      setUpdateTicketSummaryLoading(false);

      console.log(res)
    }, (err) => {
      // localStorage.setItem("ChargeMe", 0)

      alert(err.data.message)
    }))
  }

  const handleCreateDIYProject = async (file) => {
    setCreateUpdateProjectLoading(true);
    // const res = await fetch(file,
    //     {
    //         mode: 'cors',
    //         method: "GET",
    //         headers: {
    //             "Content-Type": "multipart/form-data",
    //             "Access-Control-Allow-Origin": "*",
    //             devicetype: "BROWSER",
    //         },
    //     }
    // );
    // // if (!res.ok) {
    // //     throw new Error('Failed to fetch image');
    // // }
    // const blob = await res.blob();

    // if (projectTitle === '') {
    //     setProjectTitleErr(true);
    // }

    // if (projectDescription === '' || projectDescription?.length < 10) {
    //     setProjectDescriptionErr(true);
    // }

    // if (!AITermsAndConditions) {
    //     setAITermsAndConditionsErr(true);
    // }

    // if (projectDescription !== '' && projectDescription?.length > 10 && AITermsAndConditions) {
    let formData = new FormData();

    formData.append("user_id_ids", localStorage.getItem("user_id"));
    formData.append("ticket_id", localStorage.getItem("ticket_id"));
    // formData.append("project_id_ids", projectId);
    formData.append("project_title_chr", `${serviceDetailsObj?.product_type_chr ? serviceDetailsObj?.product_type_chr : serviceDetailsObj?.category_display_name_chr} Project`);
    formData.append("category_name_chr", serviceDetailsObj?.category_name_chr);
    formData.append("project_description_chr", `${serviceDetailsObj?.product_type_chr ? serviceDetailsObj?.product_type_chr : serviceDetailsObj?.category_display_name_chr}`);
    // projectBudget && formData.append("budget_in_cents_float", parseFloat(projectBudget * 100));
    // projectPriorityLevel && formData.append("priority_int", projectPriorityLevel);
    // formData.append("difficulty_level_int", difficultyRangeValue);
    // formData.append("project_status_int", '');
    // projectCompletionDateUnix && formData.append("completion_date_dtm", projectCompletionDateUnix);

    // formData.append("attachment_id_ids0", '');
    // blob && formData.append("attachment0", file);
    // uploadAttachedImage1 != null && formData.append("attachment_id_ids1", attachedImage1Id || '');
    // uploadAttachedImage1 != null && formData.append("attachment1", uploadAttachedImage1);
    // uploadAttachedImage2 != null && formData.append("attachment_id_ids2", attachedImage2Id || '');
    // uploadAttachedImage2 != null && formData.append("attachment2", uploadAttachedImage2);

    dispatch(createUpdateProjectApi(formData, (res) => {
      setEstimationCallTabs(2);
      setCreateUpdateProjectLoading(false);
      // console.log(res.data.data, "Create update project data");
      setResponceMsg(res.data.message);

      if (res?.data?.data?.project_id_ids) {
        setProjectId(res?.data?.data?.project_id_ids);
        // localStorage.setItem("projectId", res?.data?.data?.project_id_ids);
        // localStorage.setItem("DIYprojectStep", 3);
        // navigate('/DIYproject')
      }

    }, (err) => {
      setCreateUpdateProjectLoading(false);

      setResponceMsg(err.data.message);
      setToasterType("error")

      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 11000);
    }))
    // }
  }



  const handleProDiagnosis = (e) => {
    setProDiagnosisErr(false);
    setProDiagnosis(e.target.value);
  };

  const handleProEstimatedCostMin = (e) => {
    setProEstimatedCostMin(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handleProEstimatedCostMax = (e) => {
    setProEstimatedCostMax(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  useEffect(() => {
    if (+proEstimatedCostMin > +proEstimatedCostMax) {
      setProEstimatedCostMax((+proEstimatedCostMin * 1.2).toFixed(2));
    }
  }, [proEstimatedCostMin])


  const callNoteData = () => {
    // setDiscussionLoading(true);
    let details = {
      user_id_ids: localStorage.getItem("user_id") || "",
      call_log_id_ids: localStorage.getItem("call_log_id"),
    };

    let data = new FormData();

    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));

    dispatch(
      callNoteDetails(data, (res) => {
        console.log(res.data);
        setCallNoteDetailsArr(res.data.data);
        // setDiscussionLoading(false);
      })
    );
  };

  function getCurrentDateTime() {
    const now = new Date();

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return now.toLocaleString("en-US", options);
  }

  const onLoadData = () => {
    // setCustomeSkeletonLoaing(true);

    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    data.append("generated_date_dtm", getCurrentDateTime());
    // data.append("page_index", page);
    // data.append("page_size", pageSize);
    // data.append("sorting_order", sortByValue);
    // data.append("sorting_column_name", columnName);
    // data.append("search_area", searchValue);

    dispatch(
      getPurchaseList(data, (res) => {
        getCallHistoryDetails(res);
        // setCustomeSkeletonLoaing(false);
        setPurchaseLoading(false)
      })
    );
  };

  const getCallHistoryDetails = (res) => {
    // console.log(res, "Res")
    setElements(res.data.data);
    setTotalNoRecord(res.data.total_count);
    setTotalCost(res.data?.total_estimated_cost);
    // if (res.data.total_count % pageSize === 0) {
    //   setTotalPage(parseInt(res.data.total_count / pageSize));
    // } else {
    //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
    // }


    // console.log(parseInt(res.total_records / pageSize), 'quoitent')
  };

  useEffect(() => {
    setProductType(serviceDetailsObj?.product_type_chr ? serviceDetailsObj?.product_type_chr : '');
    setBrandName(serviceDetailsObj?.device_brand_chr ? serviceDetailsObj?.device_brand_chr : '');
    setModelNumber(serviceDetailsObj?.model_number_chr ? serviceDetailsObj?.model_number_chr : "")
  }, [serviceDetailsObj])

  // this function is as per feedback given for updating the manuals real-time
  const handleSourcingInfoFn = (val = 1) => {
    // handleOpenSourcingInfoModal();
    // setProductManualFlag(val)
    if (productType === "") {
      setIsProductTypeErr(true)
    }
    if (brandName === "") {
      setIsBrandNameErr(true)
    }
    if (productType !== "" && brandName !== "") {
      setSourcingInfoLoading(true);

      let formData = new FormData();

      formData.append("product_type_chr", productType);
      formData.append("brand_name_chr", brandName);
      formData.append("model_number_chr", modelNumber);
      formData.append("specific_part_chr", specificPart);
      // formData.append("product_manual_flag", val);

      dispatch(
        // sourcingInfoFromDeviceModelApi(
        googleSourcingInfoFromDeviceModelApi(
          formData,
          (res) => {
            // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
            setSourcingInfoLoading(false);
            // updateServiceRequestFn();
            // console.log(res?.data?.data?.manual, "here");
            // const isArray = Array.isArray(res?.data?.data?.manual);
            // isArray && (
            //   val == 1 ?
            //     setSourcingInfoArr(res?.data?.data?.manual) :
            //     setSourcingInfoArr(res?.data?.data?.parts)
            // )
            setSourcingManualsArr(res?.data?.data?.manual)
            setSourcingInfoArr(res?.data?.data?.parts)
            setSourcingShoppingArr(res?.data?.data?.shopping);
            setSupportsArr(res?.data?.data?.support);

            // if (!tabsPartsManuals) {
            //   setTabsPartsManuals('1')
            // }
          },
          (res) => {
            console.log(res);
            setSourcingInfoLoading(false);

            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

            // if (!tabsPartsManuals) {
            //   setTabsPartsManuals('1')
            // }
          }
        )
      );
    }

  };

  const handlePrevAttachImg = () => {
    if (attachImageIndex !== 0) {
      setAttachImageIndex(attachImageIndex - 1)
    }
  }
  const handleNextAttachImg = () => {
    if (attachImageIndex <= serviceDetailsObj?.attachment_data?.length - 1) {
      setAttachImageIndex(attachImageIndex + 1)
    }
  }

  // Zoom functionality for the images
  // State to hold the scale value
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  // Function to handle the change in range input
  const handleZoomChange = (event) => {
    setScale(event.target.value);
  };

  // Start dragging
  const handleDragStart = (event) => {
    event.preventDefault();
    setDragging(true);
    // setPosition({
    //     ...position, // Keep the previous position
    //     startX: event.clientX - position.x, // Calculate initial start position
    //     startY: event.clientY - position.y,
    // });
    const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
    const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

    setPosition({
      ...position,
      startX: clientX - position.x,
      startY: clientY - position.y,
    });
  };

  // Handle dragging
  const handleDragging = (event) => {
    if (dragging) {
      // setPosition({
      //     ...position,
      //     x: event.clientX - position.startX,
      //     y: event.clientY - position.startY,
      // });
      const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
      const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

      setPosition({
        ...position,
        x: clientX - position.startX,
        y: clientY - position.startY,
      });
    }
  };

  // Stop dragging
  const handleDragEnd = () => {
    setDragging(false);
  };

  // Reset image
  const handleResetImage = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  }

  // Loading effect for the images
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  const handleImageLoaded = () => {
    setIsLoadingImg(false);
  };

  const handleImageError = () => {
    console.error('Failed to load the image.');
    setIsLoadingImg(false);
  };

  useEffect(() => {
    handleResetImage();
    setIsLoadingImg(true);
  }, [attachImageIndex]);

  const [imgMaxHeight, setImgMaxHeight] = useState(0);
  const [imgMaxWidth, setImgMaxWidth] = useState(0);
  const [notesMessage, setNotesMessage] = useState("");

  // Modal functions for the image preview
  const [openDoc, setOpenDoc] = React.useState(false);
  const [imageAttachURL, setImageAttachURL] = useState("");
  const handleOpenDoc = () => {
    setOpenDoc(true);
  };
  const handleCloseDoc = () => {
    setOpenDoc(false);
    setNotesMessage('');
  }

  const handleSubmitGuestForm = async (e) => {
    e?.preventDefault();
    // if (!validate()) return;

    // setSubmitting(true);
    setSubmitError("");

    // try {
    //   const result = onSubmit?.({
    //     ...fields,
    //     phone: fields.phone.replace(/\D/g, ""),
    //   });
    //   if (result?.then) {
    //     await result;
    //   }
    //   setSubmitted(true);
    // } catch {
    //   setSubmitError("Something went wrong. Please try again.");
    // } finally {
    //   setSubmitting(false);
    // }

    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true)
      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    }

    if (!isPhone) {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    } else {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    }

    if (firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
      if (isPhone) {
        let formData = new FormData();

        formData.append("first_name", firstName);
        formData.append("email_chr", '');
        formData.append("phone_code_id_int", parseInt(codeValue) || 1);
        formData.append("phone_number_int", parseInt(emailPhoneValue) || 0);
        formData.append("remark_message", messageText);
        formData.append("ticket_id", localStorage.getItem("ticket_id") || '');

        setSubmitting(true);
        setLoaderActive(true);


        dispatch(guestHomeownerForumApi(formData, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          // setHandleToaster(true);

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          setSubmitted(true);
          setSubmitting(false);

          setStepsForGuestHomeOwner(2);
          // handleSignUp(e);
          // navigate("/login");
          localStorage.setItem("isDisconnectedCall", JSON.stringify(true))


          // navigate("/activateUsers");

          setLoaderActive(false);
          // setTimeout(() => {
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setLoaderActive(false);
          setToasterType("error")
          setResponceMsg(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
          setSubmitting(false)
        }))

      } else {
        let formData = new FormData();

        formData.append("first_name", firstName);
        formData.append("email_chr", emailPhoneValue);
        // formData.append("phone_code_id_int", parseInt(codeValue) || 1);
        // formData.append("phone_number_int", parseInt(emailPhoneValue) || 0);
        formData.append("remark_message", messageText);
        formData.append("ticket_id", localStorage.getItem("ticket_id") || '');

        setSubmitting(true);
        setLoaderActive(true);

        dispatch(guestHomeownerForumApi(formData, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          // setHandleToaster(true);

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          setSubmitted(true);
          setSubmitting(false);

          setStepsForGuestHomeOwner(2);
          // handleSignUp(e);
          // navigate("/login");
          localStorage.setItem("isDisconnectedCall", JSON.stringify(true))


          // navigate("/activateUsers");

          setLoaderActive(false);
          // setTimeout(() => {
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setLoaderActive(false);
          setToasterType("error");
          setResponceMsg(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
          setSubmitting(false)
        }))

      }
    }

  };

  const handleSignUp = (e) => {
    e?.preventDefault();
    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true)
      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    }

    if (!isPhone) {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    } else {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    }

    if (!passwordValidation(password)) {
      setIsPassword(true);
      if (password === "") {
        setPasswordErrorMsg(validPassword)
      } else {
        setPasswordErrorMsg(passwordLengthText)
      }
    }

    if (!confirmPasswordValidation(password, passwordConfirm)) {
      setIsPasswordConfirm(true);
    }

    if (firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue)) && passwordValidation(password) && confirmPasswordValidation(password, passwordConfirm)) {
      if (isPhone) {
        setLoaderActive(true)
        let details = {
          first_name_chr: firstName,
          last_name_chr: '',
          alias_name_chr: '',
          role_id_list: [parseInt(role)],
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue) || 0,
          email_chr: '',
          password: password,
          confirm_password: passwordConfirm,
          creator_user_id_ids: "",
          creator_role_id_ids: "",
          referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
          zip_code_int: parseInt(zipCode),
          company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
          // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
          company_onboarding_flag: 0,
          invitation_id: localStorage.getItem("companyInvitationIdInvite") ? localStorage.getItem("companyInvitationIdInvite") : "",
          service_request_id_ids: localStorage.getItem("ticket_id") || '',
          is_guest_homeowner: 1,
        }

        dispatch(signUp(details, (res) => {
          setToasterType("success");
          setResponceMsg(res.data.message);
          // setHandleToaster(true);


          localStorage.setItem("countryCodeVal", codeValue);
          localStorage.setItem("emailPhoneVal", emailPhoneValue);

          // handleClearCompanyInvite();
          // setStepsForGuestHomeOwner(2);
          handleSubmitGuestForm(e);

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          // navigate("/activateUsers");
          // setLoaderActive(false);

          // setTimeout(() => {
          //   setLoaderActive(false);
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setToasterType("error")
          setResponceMsg(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
          setLoaderActive(false)
        }))

      } else {
        setLoaderActive(true)
        let details = {
          first_name_chr: firstName,
          last_name_chr: '',
          alias_name_chr: '',
          role_id_list: [parseInt(role)],
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue) || 0,
          email_chr: emailPhoneValue,
          password: password,
          confirm_password: passwordConfirm,
          creator_user_id_ids: "",
          creator_role_id_ids: "",
          referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
          zip_code_int: parseInt(zipCode),
          company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
          // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
          company_onboarding_flag: 0,
          invitation_id: localStorage.getItem("companyInvitationIdInvite") ? localStorage.getItem("companyInvitationIdInvite") : "",
          service_request_id_ids: localStorage.getItem("ticket_id") || '',
          is_guest_homeowner: 1,
        }

        dispatch(signUp(details, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          // setHandleToaster(true);

          localStorage.setItem("emailPhoneVal", emailPhoneValue);
          // setStepsForGuestHomeOwner(2);
          handleSubmitGuestForm(e);

          // handleClearCompanyInvite();

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          // navigate("/activateUsers");
          // setLoaderActive(false);

          // setTimeout(() => {
          //   setLoaderActive(false);
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setLoaderActive(false)

          setToasterType("error")
          setResponceMsg(res?.data?.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }))
      }
    }
  }

  const handleActivateUser = (e) => {
    e.preventDefault();

    if (recievedCodeValue) {
      if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {

        setLoaderActive(true);

        let formData = new FormData();
        formData.append("phone_code_id_int", parseInt(localStorage.getItem("countryCodeVal")) || 1);
        formData.append("phone_number_int", parseInt(localStorage.getItem("emailPhoneVal")) || 0);
        formData.append("email_chr", "");
        formData.append("otp_chr", recievedCodeValue?.trim());
        localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));
        formData.append("is_guest_homeowner", 1);

        dispatch(
          activateUser(formData, (res) => {
            // openNotification('success', 'topRight', res.data.message)
            localStorage.setItem("receiverPlatform", parseInt(localStorage.getItem("emailPhoneVal")));
            localStorage.setItem(
              "receiverPlatformPhoneCode",
              parseInt(localStorage.getItem("countryCodeVal"))
            );

            // dispatch(setIsSignUpFlagTrue());
            setStepsForGuestHomeOwner(3);
            handleShareService(e, true);

            setResponceMsg(res.data.message);
            setLoaderActive(false);
            setToasterType("success");
            // setHandleToaster(true);

            // if (res?.data?.login_flag) {
            //   handleAuthentication(res.data)
            // }
          },
            (error) => {
              console.log(error.data.message)
              // openNotification('failed', 'topRight', error.data.message)
              setResponceMsg(error.data.message);
              setToasterType("errror");
              setHandleToaster(true);
              setLoaderActive(false);

              setIsCodeError(true)

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }

      else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
        setLoaderActive(true);


        let formData = new FormData();
        // parseInt(countryCode) && formData.append("phone_code_id_int",  0);
        // parseInt(phonenumber) && formData.append("phone_number_int", 0);
        formData.append("email_chr", localStorage.getItem("emailPhoneVal"));
        formData.append("otp_chr", recievedCodeValue?.trim());
        localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));
        formData.append("is_guest_homeowner", 1);
        dispatch(
          activateUser(
            formData,
            (res) => {
              localStorage.setItem("receiverPlatform", localStorage.getItem("emailPhoneVal"));
              setLoaderActive(false);

              // dispatch(setIsSignUpFlagTrue());
              setStepsForGuestHomeOwner(3);
              handleShareService(e, true);
              setResponceMsg(res.data.message);
              setToasterType("success");

              // setHandleToaster(true);

              // if (res?.data?.login_flag) {
              //   handleAuthentication(res.data)
              // }
            },
            (error) => {
              console.log(error)

              setIsCodeError(true)

              setLoaderActive(false);
              setToasterType("error");
              setResponceMsg(error.data.message);
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          ))
      }
    } else {
      setIsCodeError(true)
    }

  }



  return (
    <>
      {

        <div style={{ width: '100vw', height: '100vh', background: 'black' }}>
          <Modal className="fade" size={((permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && !isCheckInCall) || proGivingEstimations) ? "lg" : 'md'} show={true} centered>
            {!showShareService ?
              <>
                <div className="row px-4 py-3 flex-column-reverse flex-md-row ">

                  {(permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && !isCheckInCall) && <div className="col-12 col-md-6 d-flex">
                    <div
                      className="col-12 px-0"
                      style={{ borderRight: '2px solid lightgrey' }}>

                      <div className="mx-0 row mb-4">
                        <div className="col-12  fs-6 px-0 text-center text-black ">
                          {/* <span>During the call, you earned dollars</span> */}
                        </div>
                      </div>
                      <div className='row mx-0 px-4 py-3'>
                        <div className='col-12 px-0'>

                          {/* <div className='row mx-0'>
                            <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                              <span onClick={() => handleCloseShareService()} className='cursor-pointer'>
                                <i className="bi bi-x-lg"></i>
                              </span>
                            </div>
                          </div> */}

                          <div className='row mx-0 mb-2'>
                            <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                              <span className=''>
                                {"Share service details"}
                              </span>
                            </div>
                          </div>



                          <div className='row mx-0 mt-5'>
                            <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                              <span className=' text-center'>
                                {"Share the information gathered in this call"}
                              </span>
                            </div>
                          </div>

                          <form className='w-100 mt-5' onSubmit={(e) => handleShareService(e)}>
                            <EmailPhoneCombine
                              inputValue={emailPhoneValue}
                              handleChangeCode={handleDropdownValue}
                              handleInputValue={handleEmailPhone}
                              isEnteringNumber={isPhone}
                              setIsEnteringNumber={setIsPhone}
                              errorOccured={isEmailPhoneVal}
                              errorMessage={validEmail_OR_MobileNumberText}
                              handleOnBlur={handleEmailPhoneBlur}
                              defaultCodeValue={codeValue}
                            />

                            <div className='row mx-0 mt-1'>
                              <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                <PrimaryButton
                                  buttonName={"SEND"}
                                  onClick={(e) => handleShareService(e)}
                                  loadingMessage={"SENDING..."}
                                  isLoading={shareLoading}
                                  style={{
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    border: '2px solid rgba(255, 154, 32, 1)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                  }}
                                />
                              </div>
                            </div>
                          </form>

                        </div>
                      </div>
                      <div className="mx-0 row  pb-5  mt-5">
                        <div className="col-12  fs-6 px-0 text-center  ">
                          <span className="text-black">{`Need to go back? `}</span>
                          <span
                            className="pointer font-w600"
                            onClick={() => {
                              window.location.reload()
                            }}
                            style={{
                              color: '#7c9abd'
                            }}
                          >
                            {`Rejoin call`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>}

                  <div
                    className={`col-12 ${((permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && !isCheckInCall) && !proGivingEstimations) ? 'col-md-6' : ''}`}
                  >

                    {localStorage.getItem("user_id") ?
                      <>
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") ?
                          <>
                            {proGivingEstimations ?
                              <>
                                <div className='row mx-0'>
                                  <div className='col-12 px-0'>
                                    <>
                                      <div className='mx-0 row text-black mb-4'>
                                        <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                          <span>
                                            {`Check-in report for service request #${serviceDetailsObj?.display_id_int}`}
                                          </span>
                                        </div>
                                        {/* <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                          <span onClick={() => { }} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                          </span>
                                        </div> */}
                                      </div>

                                      <div className='mx-0 row mb-4'>
                                        <div className='col-12 font-w600 fs-5 px-0 text-center'>
                                          <span>
                                            {`Please fill the information below to complete the check-in for service request (#${serviceDetailsObj?.display_id_int})`}
                                          </span>
                                        </div>
                                      </div>



                                      <div className='mx-0 row'>
                                        <div
                                          className="col-md-6 pe-md-3 fs-6"
                                          style={{ borderRight: '2px solid black' }}
                                        >
                                          {/* Navigations profile */}
                                          <div
                                            className='border-bottom mb-3 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                                          >
                                            <div className='col-12 d-flex px-0 fs-5 font-w500'>
                                              <div
                                                onClick={() => {
                                                  setTabsForEstimationsModal(1)
                                                }}
                                                className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative`}
                                                style={{}}
                                              >
                                                <span className={`${tabsForEstimationsModal === 1 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 1 && "fw-bold"}`} >{"Info"}</span>
                                                {tabsForEstimationsModal === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                                              </div>

                                              <div
                                                onClick={() => {
                                                  setTabsForEstimationsModal(2);
                                                  callNoteData();
                                                }}
                                                className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                                style={{}}
                                              >
                                                <span className={`${tabsForEstimationsModal === 2 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 2 && "fw-bold"}`}>{"Notes"}</span>
                                                {tabsForEstimationsModal === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                              </div>

                                              <div
                                                onClick={() => {
                                                  setTabsForEstimationsModal(3);
                                                  onLoadData();
                                                }}
                                                className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                                style={{}}
                                              >
                                                {/* Pro connection with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) */}
                                                {/* <span className={`${userProfileTab === 3 ? "text-black" : "text-grey"} ${userProfileTab === 3 && "fw-bold"}`}>{`Payments ${((permissionArray.includes("UPDATE WORK INFORMATION") || (role == 4)) && (serviceRequestFlagPro != 1)) ? "and Payouts" : ""} `}</span> */}
                                                <span className={`${tabsForEstimationsModal === 3 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 3 && "fw-bold"}`}>{`List`}</span>
                                                {tabsForEstimationsModal === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                              </div>

                                              <div
                                                onClick={() => {
                                                  setTabsForEstimationsModal(4)
                                                  if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                                                    handleSourcingInfoFn()
                                                  }
                                                }}
                                                className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                                style={{}}
                                              >
                                                <span className={`${tabsForEstimationsModal === 4 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 4 && "fw-bold"}`}>{"Parts & Manuals"}</span>
                                                {tabsForEstimationsModal === 4 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                              </div>

                                            </div>
                                          </div>
                                          {/* Info */}
                                          {tabsForEstimationsModal == 1 ? <>
                                            <div
                                              className="overflow-auto"
                                              style={{
                                                maxHeight: "400px",
                                              }}
                                            >
                                              <div className=" mb-3">
                                                <div>
                                                  <span className="text-black font-w600">{`Attachment : `}</span>
                                                  {/* {serviceDetailsObj?.attachment_data?.length < 0 && <span className="font-w500">{`No attachment found`}</span>} */}
                                                </div>

                                                {/* New attachments */}
                                                {/* Image attachments comes here */}
                                                <div
                                                  className="w-100 position-relative d-flex align-items-center justify-content-center"
                                                  style={{
                                                    background: "#AAA",
                                                    // borderRadius: "15px 0 0 15px",
                                                    height: "250px",
                                                    maxHeight: "250px",
                                                  }}
                                                >

                                                  {serviceDetailsObj?.attachment_data?.length > 0 &&
                                                    <div
                                                      className="align-items-center bg-black d-flex fs-7 justify-content-center position-absolute px-3 py-2 w-100"
                                                      style={{ bottom: "0px", left: "50%", transform: "translateX(-50%)", background: 'rgba(244, 248, 255, 1)', zIndex: 1 }}
                                                    >
                                                      {/* New image pagination */}
                                                      <div className="border rounded d-flex " style={{ height: '33px' }}>
                                                        <div
                                                          onClick={() => {
                                                            handlePrevAttachImg()
                                                          }}
                                                          className="d-flex justify-content-center align-items-center cursor-pointer border-end text-hovered overlay-action-btn fs-5 text-black"
                                                          style={{
                                                            width: '30px',
                                                            pointerEvents: attachImageIndex === 0 ? 'none' : 'auto',
                                                            opacity: attachImageIndex === 0 ? '0.5' : '1'
                                                          }}
                                                        >
                                                          <i class="bi bi-chevron-left"></i>
                                                        </div>
                                                        <div className="d-flex justify-content-center align-items-center" style={{ width: '50px' }}>
                                                          <span className="fs-5 font-w600" style={{ color: '#FF8934' }}>{`${attachImageIndex + 1}`}</span> &nbsp;{`/`}&nbsp;
                                                          <span className="fs-5 font-w600">{`${serviceDetailsObj?.attachment_data?.length}`}</span>
                                                        </div>
                                                        <div
                                                          onClick={() => {
                                                            handleNextAttachImg()
                                                          }}
                                                          className="d-flex justify-content-center align-items-center border-start cursor-pointer text-hovered overlay-action-btn fs-5 text-black"
                                                          style={{
                                                            width: '30px',
                                                            pointerEvents: (attachImageIndex >= serviceDetailsObj?.attachment_data?.length - 1) ? 'none' : 'auto',
                                                            opacity: (attachImageIndex >= serviceDetailsObj?.attachment_data?.length - 1) ? '0.5' : '1'
                                                          }}
                                                        >
                                                          <i class="bi bi-chevron-right"></i>
                                                        </div>
                                                      </div>



                                                      <div className="d-flex align-items-center justify-content-center ps-2">
                                                        <span className="fs-6 font-w600 pe-1">{`Zoom`}</span>
                                                        <input
                                                          className=""
                                                          type="range"
                                                          min="1"
                                                          max="3"
                                                          value={scale}
                                                          step="0.1"
                                                          onChange={handleZoomChange}
                                                          style={{
                                                            width: '80px',
                                                            margin: '20px 0',
                                                            cursor: 'pointer',
                                                            background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                                                            borderRadius: '5px',
                                                            height: '4px',
                                                            outline: 'none',
                                                            opacity: '0.7',
                                                            transition: 'opacity 0.2s',
                                                          }}
                                                        />
                                                        {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                                                          <div className=' ms-2'>
                                                            <div className="tooltipCustom">
                                                              <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                                                              <i
                                                                class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                                                onClick={() => {
                                                                  handleResetImage();
                                                                }}
                                                              ></i>
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  }

                                                  {/* {isLoadingImg &&
                                                              <div
                                                                className="d-flex align-items-center justify-content-center"
                                                                style={{
                                                                  width: "100%",
                                                                  height: "100%",
                                                                }}
                                                              >
                                                                <Spinner animation="border" size="lg" style={{}} />
                                                              </div>
                                                            } */}

                                                  {serviceDetailsObj?.attachment_data?.length > 0 ? (
                                                    <div
                                                      // ref={imageRef}
                                                      className="align-items-center border-end d-flex  justify-content-center w-100"
                                                    >
                                                      {isLoadingImg &&
                                                        <div
                                                          className="d-flex align-items-center justify-content-center w-100"
                                                          style={{
                                                            maxWidth: `250px`,
                                                            maxHeight: `250px`,
                                                            // minWidth: `${imgMaxWidth}px`,
                                                            // minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                                            width: "100%",
                                                            height: "100%",
                                                          }}
                                                        >
                                                          <Spinner animation="border" size="lg" style={{}} />
                                                        </div>
                                                      }
                                                      <div
                                                        className="overflow-hidden w-100"
                                                        style={{ cursor: dragging ? 'grabbing' : 'grab' }}
                                                        onMouseMove={handleDragging}
                                                        onMouseLeave={handleDragEnd}
                                                        onMouseUp={handleDragEnd}
                                                        onTouchMove={handleDragging}
                                                        onTouchEnd={handleDragEnd}
                                                      >
                                                        <img
                                                          src={serviceDetailsObj?.attachment_data[attachImageIndex]?.url}
                                                          alt=""
                                                          className=""
                                                          onLoad={handleImageLoaded}
                                                          onError={handleImageError}
                                                          onMouseDown={handleDragStart}
                                                          onTouchStart={handleDragStart}
                                                          style={{
                                                            maxWidth: `100%`,
                                                            maxHeight: `250px`,
                                                            minWidth: `100%`,
                                                            minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                                            width: "100%",
                                                            height: "250px",
                                                            objectFit: "contain",
                                                            // borderRadius: "15px 0 0 15px",
                                                            transition: 'transform 0.25s ease',
                                                            transformOrigin: 'center',
                                                            transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                                                            cursor: dragging ? 'grabbing' : 'grab',
                                                            display: isLoadingImg ? 'none' : 'block'
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <div
                                                      className="fs-1 text-white border-end d-flex  justify-content-center align-items-center"
                                                      style={{
                                                        maxWidth: `100%`,
                                                        maxHeight: `250px`,
                                                        minWidth: `100%`,
                                                        minHeight: '250px',
                                                        width: "100%",
                                                        height: "100%",
                                                      }}
                                                    >
                                                      <i class="bi bi-file-image-fill"></i>
                                                    </div>
                                                  )}
                                                </div>

                                              </div>

                                              <div className="mb-2">
                                                <span className="text-black font-w600">{`Problem description : `}</span>
                                                <span className="font-w500">{`${serviceDetailsObj?.problem_description_chr || 'No description found'}`}</span>
                                              </div>
                                              <div className="mb-2">
                                                <span className="text-black font-w600">{`Summary : `}</span>
                                                <span className="font-w500">{`${serviceSummaryMetaData?.recognized_image_summary || 'No summary found'}`}</span>
                                              </div>

                                              <div className="mb-2">
                                                <span className="text-black font-w600">{`Created on : `}</span>
                                                <span className="font-w500">
                                                  {`${serviceDetailsObj?.created_date_dtm ?
                                                    new Intl.DateTimeFormat("en-US", {
                                                      year: "numeric",
                                                      month: "short",
                                                      day: "numeric",
                                                      hour: 'numeric',
                                                      minute: 'numeric',
                                                      hour12: true
                                                    }).format(
                                                      serviceDetailsObj?.created_date_dtm * 1000
                                                    ) : '-'}`}
                                                </span>
                                              </div>
                                            </div>
                                          </> :
                                            // Notes
                                            tabsForEstimationsModal == 2 ?
                                              <>
                                                <div
                                                  className="col-12 overflow-auto"
                                                  style={{
                                                    maxHeight: "400px",
                                                  }}
                                                >
                                                  {callNoteDetailsArr.length === 0 && (
                                                    <div className="row mt-4">
                                                      {/* <span className="fs-7  ">
                                                                  No notes added yet
                                                                </span> */}

                                                      <div className="mb-3 d-flex justify-content-center align-items-center flex-column">
                                                        <div className="mb-2">
                                                          <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                                        </div>
                                                        <span>
                                                          {`No notes added yet`}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  )}

                                                  {callNoteDetailsArr?.map((element, index) => (
                                                    <div
                                                      className="mb-3 pb-2"
                                                      style={{ borderBottom: "1px solid gray" }}
                                                    >
                                                      <div className="row mx-0">
                                                        <div className="col-12 px-0 d-flex justify-content-between">
                                                          <div className="d-flex justify-content-center align-items-center">
                                                            <div className="pe-3">
                                                              <img src={element?.preferred_profile_picture_url} className="rounded-2" style={{ width: "40px", height: "40px" }} alt="" />
                                                            </div>

                                                            <div className="d-flex flex-column">
                                                              <div>
                                                                <span className="text-black font-w600">{`${element?.created_by_name}`}</span>
                                                              </div>

                                                              <div>
                                                                <span>
                                                                  {new Intl.DateTimeFormat("en-US", {
                                                                    year: "numeric",
                                                                    month: "short",
                                                                    day: "numeric",
                                                                    hour: 'numeric',
                                                                    minute: 'numeric',
                                                                    hour12: true
                                                                  }).format(
                                                                    element?.created_date_dtm * 1000
                                                                  )}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          {/* {localStorage.getItem("user_id") &&
                                                                    <div>
                                                                      <OverlayTrigger
                                                                        key={index}
                                                                        trigger="click"
                                                                        placement="bottom"
                                                                        // overlay={popover}
                                                                        overlay={popoverNoteActions(index)}
                                                                        rootClose={true}
                                                                        show={activePopoverNotes === index}
                                                                        onToggle={(show) =>
                                                                          setActivePopoverNotes(
                                                                            show ? index : null
                                                                          )
                                                                        }>
                                                                        <span
                                                                          style={{ position: "relative" }}>
                                                                          <LuMoreVertical
                                                                            className="pointer"
                                                                            onClick={() => {
                                                                              handleMenuClickNotes(
                                                                                element,
                                                                                index
                                                                              );
                                                                            }}
                                                                            style={{ color: "black" }}
                                                                          />
                                                                        </span>
                                                                      </OverlayTrigger>
                                                                    </div>
                                                                  } */}
                                                        </div>

                                                        <div className="col-12 mt-3">
                                                          <span
                                                            dangerouslySetInnerHTML={{
                                                              __html: element?.note_chr,
                                                            }}
                                                          />
                                                        </div>

                                                        <div className='col-12 mt-2 d-flex overflow-auto'>
                                                          {element?.attachment_url?.length > 0 &&
                                                            <>
                                                              {element?.attachment_url?.map((item, i) => {
                                                                return (
                                                                  <div key={i}>
                                                                    <img
                                                                      className="me-2 mb-2 rounded-3 cursor-pointer border"
                                                                      src={item}
                                                                      alt=""
                                                                      style={{ width: '50px', height: '60px' }}
                                                                      onClick={() => {
                                                                        handleOpenDoc();
                                                                        setImageAttachURL(item);
                                                                        element?.note_chr && setNotesMessage(element?.note_chr);
                                                                      }}
                                                                    />
                                                                  </div>
                                                                )
                                                              })}
                                                            </>
                                                          }
                                                        </div>

                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              </> :
                                              // Shopping List
                                              tabsForEstimationsModal == 3 ?
                                                <>
                                                  <div
                                                    className="col-12 overflow-auto"
                                                    style={{
                                                      height: "400px",
                                                    }}
                                                  >
                                                    {/* <div className="row mt-4">
                                                            <span className="fs-7  ">
                                                              No shopping items added yet
                                                            </span>
                                                          </div> */}
                                                    <div
                                                      className="row mt-2 pb-2"
                                                      style={{
                                                        borderBottom: "1px solid darkgrey",
                                                      }}
                                                    >
                                                      <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                                        <div>
                                                          <span>{`Added : `}</span>
                                                          <span className='font-w600 text-black'>{` ${rows.length} items`}</span>
                                                        </div>

                                                        <div>
                                                          <span>{`Total cost : `}</span>
                                                          <span className='font-w600 text-black'>
                                                            {USDollar.format(
                                                              parseFloat(totalCost.toFixed(2))
                                                            )}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>


                                                    {rows.length > 0 ?
                                                      <>
                                                        {rows?.map((element, index) => {
                                                          return (
                                                            <div
                                                              className="row mt-4 pb-2 border-bottom"
                                                              style={{
                                                                pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                                opacity: purchaseLoading ? '0.5' : '1',
                                                              }}
                                                            >
                                                              <div
                                                                className="col-12 p-2 d-flex bg-white-hovered rounded-2"
                                                              // onClick={(e) => {
                                                              //   e?.preventDefault();
                                                              //   handleViewPurchaseItemDesktop(element, 5);
                                                              // }}
                                                              >

                                                                {/* <div className='pe-3 d-flex justify-content-center'>
                                                                          <div>
                                                                            {
                                                                              <div className='rounded-2 shadow-lg'>
                                                                                <div
                                                                                  className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                  style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                >
                                                                                  <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                </div>
                                                                              </div>
                                                                            }
                                                                          </div>
                                                                        </div> */}
                                                                <div className="w-100">
                                                                  <div className="row mx-0">
                                                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                                                      <span className="fs-7">
                                                                        <span className='pe-2'>{index + 1}.</span>
                                                                        <span className="text-black font-w600">{element?.item_name_chr}</span>
                                                                      </span>
                                                                    </div>

                                                                    <div className="col-6 d-flex justify-content-end align-items-center">
                                                                      <span
                                                                        className="fs-7 text-black font-w600"
                                                                        style={{}}>
                                                                        ({element?.quantity_int}) X{" "}
                                                                        {USDollar.format(
                                                                          element?.estimated_price_float /
                                                                          element?.quantity_int
                                                                        )}{" "}
                                                                        &nbsp; &nbsp;{" "}
                                                                        {/* <OverlayTrigger
                                                                                  key={index}
                                                                                  trigger="click"
                                                                                  placement="bottom"
                                                                                  // overlay={popover}
                                                                                  overlay={popoverShoppingActions(
                                                                                    index
                                                                                  )}
                                                                                  rootClose={true}
                                                                                  show={
                                                                                    activePopoverShopping === index
                                                                                  }
                                                                                  onToggle={(show) =>
                                                                                    setActivePopoverShopping(
                                                                                      show ? index : null
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  <span style={{}}>
                                                                                    <LuMoreVertical
                                                                                      className="cursor-pointer text-black"
                                                                                      onClick={(e) => {
                                                                                        e?.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        handleMenuClickShopping(
                                                                                          element,
                                                                                          index
                                                                                        );
                                                                                      }}
                                                                                    />
                                                                                  </span>
                                                                                </OverlayTrigger> */}
                                                                      </span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-0  mt-2">
                                                                    <span className="fs-7">
                                                                      {element?.description_chr}
                                                                    </span>
                                                                  </div>

                                                                  {element?.purchase_link_chr != "" && (
                                                                    <div className="row mx-0  mt-2" ref={shoppingItemLinkWidthRef}>
                                                                      <div className="col-12 d-flex justify-content-start align-items-center">
                                                                        {urlPattern.test(element?.purchase_link_chr) ?
                                                                          <>
                                                                            <div className="d-flex align-items-center">
                                                                              <span className="text-black font-w600 fs-7 me-2">{`Website: `}</span>
                                                                              <a
                                                                                className="text-black text-hovered text-decoration-underline"
                                                                                href={
                                                                                  // element?.purchase_link_chr
                                                                                  element?.purchase_link_chr && !element?.purchase_link_chr.startsWith('http')
                                                                                    ? `https://${element?.purchase_link_chr}`
                                                                                    : element?.purchase_link_chr
                                                                                }
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                onClick={(e) => {
                                                                                  e.stopPropagation();
                                                                                }}
                                                                              >
                                                                                <span
                                                                                  className="fs-7 cursor-pointer text-truncate d-flex"
                                                                                  // style={{ maxWidth: `calc(${shoppingItemLinkWidth}px - 80px)` }}
                                                                                  style={{ maxWidth: `180px` }}
                                                                                // onClick={() => {
                                                                                //   navigator.clipboard.writeText(
                                                                                //     `${element?.purchase_link_chr}`
                                                                                //   );
                                                                                //   copyToClipboard();
                                                                                // }}
                                                                                >
                                                                                  {`${element?.purchase_link_chr}`}
                                                                                  {/* <FaArrowRightLong />{" "} */}
                                                                                </span>
                                                                              </a>
                                                                              <span >{`...`}</span>
                                                                            </div>
                                                                          </> :
                                                                          <div>
                                                                            <span className="text-black font-w600 fs-7 me-2">{`Location: `}</span>
                                                                            <span
                                                                              className="fs-7 text-black"
                                                                            >
                                                                              {element?.purchase_link_chr}
                                                                            </span>
                                                                          </div>
                                                                        }
                                                                      </div>
                                                                    </div>
                                                                  )}



                                                                  <div className="row mx-0  mt-2">
                                                                    <div className='col-12 px-0 d-flex justify-content-end'>
                                                                      {element?.is_purchased_ysn ?
                                                                        <span className='font-w600 fs-7 text-success'>{`Purchased`}</span> :
                                                                        <span className='font-w600 fs-7'>{`Not purchased yet`}</span>
                                                                      }
                                                                    </div>
                                                                  </div>


                                                                </div>

                                                              </div>

                                                            </div>
                                                          );
                                                        })}
                                                      </> :
                                                      <>
                                                        <div className="mb-3 mt-4 d-flex justify-content-center align-items-center flex-column">
                                                          <div className="mb-2">
                                                            <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                                          </div>
                                                          <span>
                                                            {`No items added yet`}
                                                          </span>
                                                        </div>
                                                      </>
                                                    }

                                                  </div>
                                                </> :
                                                // Parts and Manuals
                                                tabsForEstimationsModal == 4 ?
                                                  <>
                                                    {/* Navigation Menu for Parts and Manuals */}
                                                    <div className="row mx-0 bg-white">
                                                      <div className="col-12 px-0 position-relative">




                                                        {/* Navigations */}
                                                        <div
                                                          ref={navRef}
                                                          className='border-bottom overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                                                          style={{ scrollBehavior: 'smooth', display: 'flex' }}
                                                        >
                                                          <div className='col-12 d-flex px-0 fs-5 font-w500'>
                                                            <div
                                                              onClick={() => {
                                                                // handleSourcingInfoFn(1);
                                                                setTabsPartsManuals('1');
                                                              }}
                                                              className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative`}
                                                              style={{}}
                                                            >
                                                              <div
                                                                className={`${tabsPartsManuals === '1' ? "text-black" : "text-grey"} ${tabsPartsManuals === '1' && "fw-bold"} d-flex align-items-center justify-content-center flex-column`}
                                                              >
                                                                <span className={``}>{`Manuals`}</span>
                                                                {/* <span className={``}>{`manual`}</span> */}
                                                              </div>
                                                              {/* <span className={`${tabsPartsManuals === 1 ? "text-black" : "text-grey"} ${tabsPartsManuals === 1 && "fw-bold"}`} >{"Owners manual"}</span> */}
                                                              {tabsPartsManuals === '1' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}

                                                            </div>

                                                            <div
                                                              onClick={() => {
                                                                // handleSourcingInfoFn(0);
                                                                setTabsPartsManuals('2');
                                                              }}
                                                              className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                                              style={{}}
                                                            >
                                                              <div
                                                                className={`${tabsPartsManuals === '2' ? "text-black" : "text-grey"} ${tabsPartsManuals === '2' && "fw-bold"} d-flex align-items-center justify-content-center flex-column`}
                                                              >
                                                                <span className={``}>{`Parts`}</span>
                                                              </div>
                                                              {/* <span className={`${tabsPartsManuals === 2 ? "text-black" : "text-grey"} ${tabsPartsManuals === 2 && "fw-bold"}`}>{`Parts and tools`}</span> */}
                                                              {tabsPartsManuals === '2' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                                            </div>

                                                            <div
                                                              onClick={() => {
                                                                // handleSourcingInfoFn(0);
                                                                setTabsPartsManuals('3');
                                                              }}
                                                              className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                                              style={{}}
                                                            >
                                                              <span className={`${tabsPartsManuals === '3' ? "text-black" : "text-grey"} ${tabsPartsManuals === '3' && "fw-bold"} align-self-center`}>{`Replacements`}</span>
                                                              {tabsPartsManuals === '3' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className="row mx-0 overflow-auto"
                                                      style={{ maxHeight: "400px" }}
                                                    >
                                                      <div className="col-12 p-2">

                                                        {tabsPartsManuals == '2' && productType !== "" && brandName !== "" &&
                                                          <div className="row mx-0 mb-3">
                                                            <div className="col-12 px-0">

                                                              <div className="row mx-0">
                                                                <div className="col-12 px-0 d-flex">
                                                                  <div
                                                                    onClick={() => {
                                                                      setSourcingInfoTabs(1)
                                                                    }}
                                                                    className={`${sourcingInfoTabs === 1 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                                                    style={{ minWidth: '50px' }}
                                                                  >
                                                                    <span>{`All`}</span>
                                                                  </div>

                                                                  <div
                                                                    onClick={() => {
                                                                      setSourcingInfoTabs(2)
                                                                    }}
                                                                    className={`${sourcingInfoTabs === 2 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                                                    style={{ minWidth: '50px' }}
                                                                  >
                                                                    <span>{`Supports`}</span>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        }

                                                        <div className="row mx-0 mt-3 pb-2">
                                                          <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">

                                                            <div className="w-100">
                                                              {sourcingInfoLoading ? <div>
                                                                <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                                                <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                                                <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                                                <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                                              </div> :
                                                                <>
                                                                  {tabsPartsManuals == '1' ?
                                                                    <>
                                                                      {sourcingManualsArr?.length > 0 ?
                                                                        <>
                                                                          {sourcingManualsArr?.map((item, index) => {
                                                                            return (
                                                                              <>
                                                                                <a target="_blank" href={item?.url} rel="noreferrer">
                                                                                  <div className="mx-0 row mb-2">
                                                                                    <div
                                                                                      className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                                      style={{
                                                                                        background: "rgba(244, 248, 255, 1)",
                                                                                        border: "1px solid rgba(199, 212, 234, 1)",
                                                                                      }}
                                                                                    >
                                                                                      <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                                        <div className="d-flex">
                                                                                          <div
                                                                                            className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                                            style={{ width: "30px", height: "30px" }}
                                                                                          >
                                                                                            <img
                                                                                              src={item?.image}
                                                                                              style={{ width: "30px", height: "30px" }}
                                                                                              className="rounded-3"
                                                                                              alt=""
                                                                                            />
                                                                                          </div>

                                                                                          {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                                          <div className="d-flex flex-column">
                                                                                            <span className="fs-6 text-black">
                                                                                              {`${item?.name}`}
                                                                                            </span>
                                                                                            <span className="fs-7">
                                                                                              {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                                            </span>
                                                                                          </div>

                                                                                        </div>

                                                                                        <div>
                                                                                          <i className="bi bi-chevron-right" />
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>
                                                                                  </div>
                                                                                </a>
                                                                              </>
                                                                            )
                                                                          })}
                                                                        </> :
                                                                        <>
                                                                          <div>
                                                                            <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                                              <div className="mb-2">
                                                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                                              </div>
                                                                              <span>
                                                                                {`No record found`}
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      }
                                                                    </> :
                                                                    tabsPartsManuals == '2' ?
                                                                      <>
                                                                        {sourcingInfoTabs == 1 ?
                                                                          <>
                                                                            {sourcingInfoArr?.length > 0 ?
                                                                              <>
                                                                                {sourcingInfoArr?.map((item, index) => {
                                                                                  return (
                                                                                    <>
                                                                                      <a target="_blank" href={item?.url} rel="noreferrer">
                                                                                        <div className="mx-0 row mb-2">
                                                                                          <div
                                                                                            className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                                            style={{
                                                                                              background: "rgba(244, 248, 255, 1)",
                                                                                              border: "1px solid rgba(199, 212, 234, 1)",
                                                                                            }}
                                                                                          >
                                                                                            <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                                              <div className="d-flex">
                                                                                                <div
                                                                                                  className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                                                  style={{ width: "30px", height: "30px" }}
                                                                                                >
                                                                                                  <img
                                                                                                    src={item?.image}
                                                                                                    style={{ width: "30px", height: "30px" }}
                                                                                                    className="rounded-3"
                                                                                                    alt=""
                                                                                                  />
                                                                                                </div>

                                                                                                {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                                                <div className="d-flex flex-column">
                                                                                                  <span className="fs-6 text-black">
                                                                                                    {`${item?.name}`}
                                                                                                  </span>
                                                                                                  <span className="fs-7">
                                                                                                    {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                                                  </span>
                                                                                                </div>

                                                                                              </div>

                                                                                              <div>
                                                                                                <i className="bi bi-chevron-right" />
                                                                                              </div>
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </a>
                                                                                    </>
                                                                                  )
                                                                                })}
                                                                              </> :
                                                                              <>
                                                                                <div>
                                                                                  <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                                                    <div className="mb-2">
                                                                                      <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                                                    </div>
                                                                                    <span>
                                                                                      {`No record found`}
                                                                                    </span>
                                                                                  </div>
                                                                                </div>
                                                                              </>
                                                                            }
                                                                          </> :
                                                                          sourcingInfoTabs == 2 ?
                                                                            <>
                                                                              {supportsArr?.length > 0 ?
                                                                                <>
                                                                                  {supportsArr?.map((item, index) => {
                                                                                    return (
                                                                                      <>
                                                                                        <a target="_blank" href={item?.url} rel="noreferrer">
                                                                                          <div className="mx-0 row mb-2">
                                                                                            <div
                                                                                              className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                                              style={{
                                                                                                background: "rgba(244, 248, 255, 1)",
                                                                                                border: "1px solid rgba(199, 212, 234, 1)",
                                                                                              }}
                                                                                            >
                                                                                              <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                                                <div className="d-flex">
                                                                                                  <div
                                                                                                    className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                                                    style={{ width: "30px", height: "30px" }}
                                                                                                  >
                                                                                                    <img
                                                                                                      src={item?.image}
                                                                                                      style={{ width: "30px", height: "30px" }}
                                                                                                      className="rounded-3"
                                                                                                      alt=""
                                                                                                    />
                                                                                                  </div>

                                                                                                  {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                                                  <div className="d-flex flex-column">
                                                                                                    <span className="fs-6 text-black">
                                                                                                      {`${item?.name}`}
                                                                                                    </span>
                                                                                                    <span className="fs-7">
                                                                                                      {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                                                    </span>
                                                                                                  </div>

                                                                                                </div>

                                                                                                <div>
                                                                                                  <i className="bi bi-chevron-right" />
                                                                                                </div>
                                                                                              </div>
                                                                                            </div>
                                                                                          </div>
                                                                                        </a>
                                                                                      </>
                                                                                    )
                                                                                  })}
                                                                                </> :
                                                                                <>
                                                                                  <div>
                                                                                    <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                                                      <div className="mb-2">
                                                                                        <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                                                      </div>
                                                                                      <span>
                                                                                        {`No record found`}
                                                                                      </span>
                                                                                    </div>
                                                                                  </div>
                                                                                </>
                                                                              }
                                                                            </> : <></>
                                                                        }
                                                                      </> :
                                                                      tabsPartsManuals == '3' ?
                                                                        <>
                                                                          {sourcingShoppingArr?.length > 0 ?
                                                                            <>
                                                                              {sourcingShoppingArr?.map((item, index) => {
                                                                                return (
                                                                                  <>
                                                                                    <a target="_blank" href={item?.url} rel="noreferrer">
                                                                                      <div className="mx-0 row mb-2">
                                                                                        <div
                                                                                          className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                                          style={{
                                                                                            background: "rgba(244, 248, 255, 1)",
                                                                                            border: "1px solid rgba(199, 212, 234, 1)",
                                                                                          }}
                                                                                        >
                                                                                          <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                                            <div className="d-flex">
                                                                                              <div
                                                                                                className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                                                style={{ width: "30px", height: "30px" }}
                                                                                              >
                                                                                                <img
                                                                                                  src={item?.image}
                                                                                                  style={{ width: "30px", height: "30px" }}
                                                                                                  className="rounded-3"
                                                                                                  alt=""
                                                                                                />
                                                                                              </div>

                                                                                              {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                                              <div className="d-flex flex-column">
                                                                                                <span className="fs-6 text-black">
                                                                                                  {`${item?.name}`}
                                                                                                </span>
                                                                                                <span className="fs-7">
                                                                                                  {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                                                </span>
                                                                                              </div>

                                                                                            </div>

                                                                                            <div>
                                                                                              <i className="bi bi-chevron-right" />
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>
                                                                                    </a>
                                                                                  </>
                                                                                )
                                                                              })}
                                                                            </> :
                                                                            <>
                                                                              <div>
                                                                                <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                                                  <div className="mb-2">
                                                                                    <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                                                  </div>
                                                                                  <span>
                                                                                    {`No record found`}
                                                                                  </span>
                                                                                </div>
                                                                              </div>
                                                                            </>
                                                                          }
                                                                        </>
                                                                        : <></>
                                                                  }


                                                                </>
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>

                                                    </div>
                                                  </> : <></>
                                          }

                                        </div>

                                        <div className="col-md-6 ps-md-3">
                                          <form
                                            onSubmit={(e) => {
                                              handleUpdateTicketSummary(e)
                                            }}
                                            className="mt-1"
                                          >
                                            <div className='row mb-4'>
                                              <div className='col-12 px-0'>
                                                <div className="row mx-0">
                                                  <div className="row">
                                                    <div className="col-12 px-0">
                                                      <TextArea
                                                        labelName={"Diagnosis *"}
                                                        placeholderName={"Diagnosis"}
                                                        value={`${proDiagnosis}`}
                                                        onChange={(e) => { handleProDiagnosis(e) }}
                                                        onBlur={() => { }}
                                                        errorOccured={proDiagnosisErr}
                                                        errorMessage={"Please add Diagnosis"}
                                                        isRequired={true}
                                                        rows={3}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row">
                                                    <div className="col-12 px-0 mb-2">
                                                      <span className="fs-5 text-black font-w500">{`Estimated Cost Range`}</span>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-6 px-0 pe-2">
                                                        <InputField
                                                          labelName={"Low ($)"}
                                                          placeholderName={"Low ($)"}
                                                          value={`${proEstimatedCostMin}`}
                                                          onChange={(e) => { handleProEstimatedCostMin(e) }}
                                                          onBlur={() => { }}
                                                          errorOccured={false}
                                                          errorMeesage={"Please add Labor"}
                                                        />
                                                      </div>
                                                      <div className="col-6 px-0 ps-2">
                                                        <InputField
                                                          labelName={"High ($)"}
                                                          placeholderName={"High ($)"}
                                                          value={`${proEstimatedCostMax}`}
                                                          onChange={(e) => { handleProEstimatedCostMax(e) }}
                                                          onBlur={() => { }}
                                                          errorOccured={false}
                                                          errorMeesage={"Please add Labor"}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="row">
                                                    <div className="col-12 px-0 mb-3">
                                                      <span className="fs-5 text-black font-w500">{`Solution recommendation`}</span>
                                                    </div>

                                                    <div className="row">
                                                      <div
                                                        className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                                        onClick={() => {
                                                          setProRecommendedSolution(1);
                                                        }}
                                                        style={{
                                                          border: proRecommendedSolution == 1 ? "2px solid orange" : "2px solid lightgray",
                                                          background: proRecommendedSolution == 1 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                                          color: proRecommendedSolution == 1 ? "white" : "black",
                                                        }}
                                                      >
                                                        <span className="fs-5 font-w600 text-center">{`DIY with Chilll Toolbox`}</span>
                                                        <span className="fs-6 text-center">{`Free`}</span>
                                                      </div>

                                                      <div
                                                        className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                                        onClick={() => {
                                                          setProRecommendedSolution(2);
                                                        }}
                                                        style={{
                                                          border: proRecommendedSolution == 2 ? "2px solid orange" : "2px solid lightgray",
                                                          background: proRecommendedSolution == 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                                          color: proRecommendedSolution == 2 ? "white" : "black",
                                                        }}
                                                      >
                                                        <span className="fs-5 font-w600 text-center">{`DIY with Remote Pro`}</span>
                                                        <span className="fs-6 text-center">
                                                          {`${USDollar.format(
                                                            parseFloat(callChargeAmount?.toFixed(2))
                                                          )} for ${callDurationTimeLimit} minutes`}
                                                        </span>
                                                      </div>

                                                      <div
                                                        className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                                        onClick={() => {
                                                          setProRecommendedSolution(3);
                                                        }}
                                                        style={{
                                                          border: proRecommendedSolution == 3 ? "2px solid orange" : "2px solid lightgray",
                                                          background: proRecommendedSolution == 3 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                                          color: proRecommendedSolution == 3 ? "white" : "black",
                                                        }}
                                                      >
                                                        <span className="fs-5 font-w600 text-center">{`Get Local Pro`}</span>
                                                        <span className="fs-6 text-center">{`Free matching on your terms`}</span>
                                                      </div>
                                                    </div>

                                                    {proRecommendedSolutionErr &&
                                                      <div>
                                                        <span className="text-danger font-w500 fs-12">{`Please select one of the above options`}</span>
                                                      </div>
                                                    }
                                                  </div>



                                                </div>
                                              </div>
                                            </div>

                                            <div className='row mx-0 mt-2'>
                                              <div className='col-12 px-0'>
                                                <PrimaryButton
                                                  onClick={(e) => {
                                                    handleUpdateTicketSummary(e);
                                                  }}
                                                  buttonName={"SUBMIT"}
                                                  type="submit"
                                                  loadingMessage="SUBMITTING..."
                                                  isLoading={updateTicketSummaryLoading}
                                                  style={{
                                                    width: "100%",
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    border: '1px solid rgba(255, 154, 32, 1)',
                                                    fontWeight: '600',
                                                  }}
                                                />
                                              </div>
                                            </div>

                                          </form>
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                              </> :
                              <>
                                <div className="col-12 px-4">
                                  <div className="mx-0 row">
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                      <span className="">
                                        <i className="bi bi-x-lg cursor-pointer"
                                          onClick={(e) => {
                                            navigate("/dashboard");
                                            localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                          }}
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="mx-0 row mb-4">

                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                      <span>{formatTime(localStorage.getItem("timeUsedInSeconds"))}</span>
                                    </div>
                                  </div>
                                  <div className="mx-0 row mb-4">
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black mt-3">
                                      <span>Are you satisfied with this job?</span>
                                    </div>
                                  </div>
                                  <div className="mx-0 row mb-4">
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                      {/* May be create a separate component for this rating */}

                                      <div
                                        style={{ display: "flex", justifyContent: "center" }}>
                                        {[...Array(5)].map((star, i) => {
                                          const ratingValue = i + 1;
                                          return (
                                            <label key={i}>
                                              <input
                                                type="radio"
                                                name="rating"
                                                value={ratingValue}
                                                onClick={(e) => {
                                                  setRating(ratingValue == 0 ? 1 : ratingValue);

                                                }}
                                                style={{ display: "none" }}
                                              />
                                              {ratingValue <= (hover || rating) ? (
                                                <BsStarFill
                                                  onMouseEnter={() => setHover(ratingValue)}
                                                  onMouseLeave={() => setHover(0)}
                                                  className="star"
                                                  style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    cursor: "pointer",
                                                    color: "gold",
                                                  }}
                                                />
                                              ) : (
                                                <BiStar
                                                  onMouseEnter={() => setHover(ratingValue)}
                                                  onMouseLeave={() => setHover(0)}
                                                  className="star"
                                                  style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    cursor: "pointer",
                                                    color: "gray",
                                                  }}
                                                />
                                              )}
                                            </label>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mx-0 row mt-4">
                                    <div className="col-12  fs-7 px-0 text-center ">
                                      <TextArea
                                        labelName={"You feedback"}
                                        placeholder={"Message..."}
                                        onChange={(e) => {
                                          setFeedbackMessage(e.target.value);
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="row mx-0 mt-2">
                                    <div className="col-12 px-0 fs-7  mb-2">
                                      <PrimaryButton
                                        onClick={submitFeedback}
                                        loadingMessage={"SUBMITTING..."}
                                        isLoading={isLoading}
                                        buttonName={"SEND FEEDBACK"}
                                        type={"submit"}
                                        style={{
                                          width: "100%",
                                          background: "green",
                                          border: "1px solid green",
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {isCheckInCall &&
                                    <div className="mx-0 row my-3">
                                      <div className="col-12  fs-6 px-0 text-center  ">
                                        <span className="text-black">{`Need to go back? `}</span>
                                        <span
                                          className="pointer font-w600"
                                          onClick={() => {
                                            window.location.reload()
                                          }}
                                          style={{
                                            color: '#7c9abd'
                                          }}
                                        >
                                          {`Rejoin call`}
                                        </span>
                                      </div>
                                    </div>
                                  }


                                  {/* 
                              {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && <div className="row mx-0 my-2">
                                <div className="col-12 px-0 ">
                                  <div
                                    className="p-2 d-flex justify-content-center aligh-items-center cursor-pointer text-hovered text-black font-w600"
                                    onClick={handleShowShareService}
                                  >
                                    <span className="me-2 d-flex fs-5">
                                      <FaShare />
                                    </span>
                                    <span className="text-center">{`Share service details`}</span>
                                  </div>
                                </div>
                              </div>} */}

                                </div>
                              </>
                            }

                          </>
                          :
                          <>
                            <div className="position-relative">
                              {(updateTicketSummaryLoading || createUpdateProjectLoading) ?
                                <div
                                  className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                  style={{
                                    pointerEvents: "none !important",
                                    background: "rgb(255 255 255 / 94%)",
                                    zIndex: "999"
                                  }}
                                >
                                  <Spinner animation="border" variant="primary" />
                                </div> : <></>
                              }

                              {
                                (localStorage.getItem("user_id") === process.env.REACT_APP_GUEST_USER_ID_IDS) || (localStorage.getItem("guest_user_id") === process.env.REACT_APP_GUEST_USER_ID_IDS) ?
                                  <>
                                    {stepsForGuestHomeOwner == 1 ?
                                      <>
                                        <div className="row mx-0">
                                          <div className="col-12 px-0">

                                            <div className="mx-0 row">
                                              <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                                <span className="">
                                                  <i className="bi bi-x-lg cursor-pointer"
                                                    onClick={(e) => {
                                                      navigate("/dashboard");
                                                      localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                    }}
                                                  ></i>
                                                </span>
                                              </div>
                                            </div>

                                            {/* <div className="mx-0 row mb-4">
                                          <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                            <span>{formatTime(localStorage.getItem("timeUsedInSeconds"))}</span>
                                          </div>
                                        </div> */}

                                            <div className="row mx-0">
                                              <div className="col-12 px-0">

                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black">
                                                    <span className="text-center">{`Thank you for working with Chilll. We hope you had a great experience`}</span>
                                                  </div>
                                                </div>

                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                    <img src={acceptServiceImg} alt="service" style={{ width: "40px", height: "52px" }} />
                                                  </div>
                                                </div>

                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                    <span className="text-center">
                                                      {/* {`Leave your info and we'll follow up. Email or phone is required.`} */}
                                                      {`Your Pro is Preparing Your Estimate. Please provide some information so that we can deliver the estimate.`}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div>
                                                  <div className="row d-flex justify-content-between mt-2">
                                                    <div className="col-12">
                                                      <InputField
                                                        labelName={lblFirstName}
                                                        value={firstName}
                                                        onChange={handleFirstName}
                                                        errorOccured={isFirstNameError}
                                                        errorMeesage={errorFirstNameMsg}
                                                        onBlur={() => { }}
                                                        isRequired={true}
                                                      // autoF={true}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row">
                                                    <InputField
                                                      labelName={"Zip code"}
                                                      value={zipCode}
                                                      onChange={(e) => { handleZipCode(e) }}
                                                      errorOccured={false}
                                                      errorMeesage={""}
                                                      onBlur={() => { }}
                                                    />
                                                  </div>
                                                  <div className="row mb-2">
                                                    <EmailPhoneCombine
                                                      isEnteringNumber={isPhone}
                                                      setIsEnteringNumber={setIsPhone}
                                                      handleInputValue={handleEmailPhone}
                                                      handleChangeCode={handleDropdownValue}
                                                      errorOccured={isEmailPhoneVal}
                                                      inputValue={emailPhoneValue}
                                                      handleOnBlur={handleEmailPhoneBlur}
                                                      defaultCodeValue={codeValue}
                                                      errorMessage={
                                                        // validEmail_OR_MobileNumberText
                                                        loginErrorMsg
                                                      }
                                                      isRequired={true}
                                                    />
                                                  </div>



                                                  {/* <div className='mb-2 mx-0 row'>
                                                <div className='col-12 px-0'>
                                                  <TextArea
                                                    labelName={`Message`}
                                                    placeholder={`Message`}
                                                    value={messageText}
                                                    onChange={handleMessageText}
                                                    rows='3'
                                                    onBlur={() => { }}
                                                  />
                                                </div>
                                              </div> */}
                                                </div>

                                                <div>


                                                  <div className="row mx-0 text-black mt-4 mb-2">
                                                    <div className="col-12 "
                                                      style={{
                                                        // pointerEvents: jobStatus == 2 ? "none" : "auto",
                                                        // opacity: jobStatus == 2 ? "0.5" : "1",
                                                      }}
                                                    >
                                                      <PrimaryButton
                                                        onClick={(e) => {
                                                          // handleSubmitGuestForm(e);
                                                          handleSignUp(e);
                                                        }}
                                                        buttonName={`SUBMIT`}
                                                        loadingMessage={"Loading..."}
                                                        // isLoading={submitting}
                                                        isLoading={loaderActive}
                                                        style={{
                                                          width: "100%",
                                                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                          border: '2px solid rgba(255, 154, 32, 1)',
                                                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                          borderRadius: '4px'
                                                        }}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row my-3">
                                                    <div className="col-12  fs-6 px-0 text-center  ">
                                                      <span className="text-black">{`Need to go back? `}</span>
                                                      <span
                                                        className="pointer font-w600"
                                                        onClick={() => {
                                                          window.location.reload()
                                                        }}
                                                        style={{
                                                          color: '#7c9abd'
                                                        }}
                                                      >
                                                        {`Rejoin call`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </> :
                                      stepsForGuestHomeOwner == 2 ?
                                        <>
                                          <div className="row mx-0">
                                            <div className="col-12 px-0">

                                              {/* <div className="mx-0 row">
                                                <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                                  <span className="">
                                                    <i className="bi bi-x-lg cursor-pointer"
                                                      onClick={(e) => {
                                                        navigate("/dashboard");
                                                        localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                      }}
                                                    ></i>
                                                  </span>
                                                </div>
                                              </div> */}

                                              <div className="mx-0 row mb-4">
                                                <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                                  <span>{`Verification Code`}</span>
                                                </div>
                                              </div>

                                              <div className="row mx-0">
                                                <div className="col-12 px-0">

                                                  <div className="row mx-0 mb-1">
                                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-6 text-black">
                                                      <span className="text-center">{`We sent the verification code to`}</span>
                                                    </div>
                                                  </div>

                                                  {/* <div className="row mx-0 mb-3">
                                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                      <img src={acceptServiceImg} alt="service" style={{ width: "40px", height: "52px" }} />
                                                    </div>
                                                  </div> */}

                                                  <div className="row mx-0 mb-4">
                                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                      <span className="text-center">
                                                        {/* {`Leave your info and we'll follow up. Email or phone is required.`} */}
                                                        {emailPhoneValue}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <form onSubmit={handleActivateUser} autoComplete={false}>

                                                    <div className="row">
                                                      <InputField
                                                        labelName={hintEnterValidationCode}
                                                        placeholderName={hintEnterValidationCode}
                                                        value={recievedCodeValue}
                                                        onChange={handleValidateCode}
                                                        errorOccured={isCodeError}
                                                        errorMeesage={"Invalid code"}
                                                        onBlur={() => { }}
                                                      />
                                                    </div>

                                                    <PrimaryButton
                                                      buttonName={btnVerify}
                                                      type={"submit"}
                                                      onClick={handleActivateUser}
                                                      isLoading={loaderActive}
                                                      loadingMessage={"Loading..."}
                                                      style={{
                                                        width: "100%",
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                      }}
                                                    />
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </> :
                                        stepsForGuestHomeOwner == 3 ?
                                          <>
                                            <div className="row mx-0">
                                              <div className="col-12 px-0">

                                                {/* <div className="mx-0 row">
                                                <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                                  <span className="">
                                                    <i className="bi bi-x-lg cursor-pointer"
                                                      onClick={(e) => {
                                                        navigate("/dashboard");
                                                        localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                      }}
                                                    ></i>
                                                  </span>
                                                </div>
                                              </div> */}

                                                <div className="row mx-0 mb-4">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                    <img src={logo} alt="service" style={{ width: "120px", height: "52px" }} />
                                                  </div>
                                                </div>

                                                <div className="mx-0 row mb-4">
                                                  <div className="col-12 font-w600 fs-4 px-0 text-center text-black ">
                                                    <span>{`Thanks for your time.  Once your free estimate is completed, we will send you an (sms text/email) with a link to open your estimate.`}</span>
                                                  </div>
                                                </div>

                                                <div className="row mx-0">
                                                  <div className="col-12 px-0">

                                                    <PrimaryButton
                                                      buttonName={"Okay"}
                                                      type={"submit"}
                                                      onClick={() => {
                                                        // navigate("/login");
                                                        window.open("https://chilll.com/", "_self");
                                                      }}
                                                      isLoading={loaderActive}
                                                      loadingMessage={"Loading..."}
                                                      style={{
                                                        width: "100%",
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </> : <></>
                                    }

                                  </> :
                                  <>
                                    {!isEstimationsCall ?
                                      <>
                                        <div className="row mx-0">
                                          <div className="col-12 px-0">

                                            <div className="mx-0 row">
                                              <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                                <span className="">
                                                  <i className="bi bi-x-lg cursor-pointer"
                                                    onClick={(e) => {
                                                      navigate("/dashboard");
                                                      localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                    }}
                                                  ></i>
                                                </span>
                                              </div>
                                            </div>

                                            <div className="mx-0 row mb-4">
                                              <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                                <span>{formatTime(localStorage.getItem("timeUsedInSeconds"))}</span>
                                              </div>
                                            </div>

                                            <div className="row mx-0">
                                              <div className="col-12 px-0">

                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black">
                                                    <span className="text-center">{`Thank you for working with Chilll. We hope you had a great experience`}</span>
                                                  </div>
                                                </div>

                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                    <img src={acceptServiceImg} alt="service" style={{ width: "40px", height: "52px" }} />
                                                  </div>
                                                </div>

                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                    <span className="text-center">{`Please select desired status for your service request`}</span>
                                                  </div>
                                                </div>

                                                <div>
                                                  {/* Resolved */}
                                                  <div
                                                    className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered  bg-white"
                                                    onClick={() => { setJobStatus(0) }}
                                                    style={{
                                                      border: jobStatus == 0 ? '2px solid orange' : '',
                                                    }}
                                                  >
                                                    <div className="col-12 px-0 font-w600 d-flex align-items-center">
                                                      <div className='d-flex'>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                          <div className="pe-4">
                                                            {/* <input
                                                  className="form-check-input"
                                                  style={{ display: 'inline-block' }}
                                                  name="selectJobStatus"
                                                  type="radio"
                                                  value={0}
                                                  onChange={(e) => { setJobStatus(0) }}
                                                  checked={jobStatus == 0}
                                              /> */}
                                                          </div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                          <span className='font-w700 text-black fs-5'>{`Resolved`}</span>
                                                          <span className=''>{`The issue is completed to my satisfaction`}</span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {jobStatus == 0 &&
                                                      <>
                                                        <div className='col-12 px-0 d-flex align-items-center justify-content-center flex-column mt-2'>
                                                          <div>
                                                            <span className='fs-5 text-black font-w700'>{`How would you rate the a Pro's help?`}</span>
                                                          </div>
                                                          <div>
                                                            <div
                                                              className="font-w600 fs-3 mb-3"
                                                              style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                              {[...Array(5)].map((star, i) => {
                                                                const ratingValue = i + 1;
                                                                return (
                                                                  <label key={i}>
                                                                    <input
                                                                      type="radio"
                                                                      name="rating"
                                                                      value={ratingValue}
                                                                      onClick={(e) => {
                                                                        setRating(ratingValue == 0 ? 1 : ratingValue);

                                                                      }}
                                                                      style={{ display: "none" }}
                                                                    />
                                                                    {ratingValue <= (hover || rating) ? (
                                                                      <BsStarFill
                                                                        onMouseEnter={() => setHover(ratingValue)}
                                                                        onMouseLeave={() => setHover(0)}
                                                                        className="star"
                                                                        style={{
                                                                          width: "24px",
                                                                          height: "24px",
                                                                          cursor: "pointer",
                                                                          color: "gold",
                                                                        }}
                                                                      />
                                                                    ) : (
                                                                      <BiStar
                                                                        onMouseEnter={() => setHover(ratingValue)}
                                                                        onMouseLeave={() => setHover(0)}
                                                                        className="star"
                                                                        style={{
                                                                          width: "24px",
                                                                          height: "24px",
                                                                          cursor: "pointer",
                                                                          color: "gray",
                                                                        }}
                                                                      />
                                                                    )}
                                                                  </label>
                                                                );
                                                              })}
                                                              {/* <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span> */}
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className='col-12 px-0'>
                                                          <TextArea
                                                            // onChange={onChangeFeedBackMsg}
                                                            value={feedbackMessage}
                                                            labelName={`Your feedback(optional)`}
                                                            rows={'2'}
                                                            onChange={(e) => { setFeedbackMessage(e.target.value) }}
                                                            onBlur={() => { }}
                                                          />
                                                        </div>
                                                      </>
                                                    }

                                                  </div>

                                                  {/* Unresolved */}
                                                  <div
                                                    className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered  bg-white"
                                                    onClick={() => { setJobStatus(4) }}
                                                    style={{
                                                      border: jobStatus == 4 ? '2px solid orange' : '',
                                                    }}
                                                  >
                                                    <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                      <div className='d-flex'>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                          <div className="pe-4">
                                                            {/* <input
                                                  className="form-check-input"
                                                  style={{ display: 'inline-block' }}
                                                  name="selectJobStatus"
                                                  type="radio"
                                                  value={4}
                                                  onChange={(e) => { setJobStatus(4) }}
                                                  checked={jobStatus == 4}
                                              /> */}
                                                          </div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                          <span className='font-w700 text-black fs-5'>{`Unresolved`}</span>
                                                          <span className=''>{`The Pro was unable to assit me`}</span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {jobStatus == 4 &&
                                                      <>
                                                        <div className='col-12 px-0 d-flex align-items-center justify-content-center flex-column mt-2'>
                                                          <div>
                                                            <span className='fs-5 text-black font-w700'>{`How would you rate the a Pro's help?`}</span>
                                                          </div>
                                                          <div>
                                                            <div
                                                              className="font-w600 fs-3 mb-3"
                                                              style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                              {[...Array(5)].map((star, i) => {
                                                                const ratingValue = i + 1;
                                                                return (
                                                                  <label key={i}>
                                                                    <input
                                                                      type="radio"
                                                                      name="rating"
                                                                      value={ratingValue}
                                                                      onClick={(e) => {
                                                                        setRating(ratingValue == 0 ? 1 : ratingValue);

                                                                      }}
                                                                      style={{ display: "none" }}
                                                                    />
                                                                    {ratingValue <= (hover || rating) ? (
                                                                      <BsStarFill
                                                                        onMouseEnter={() => setHover(ratingValue)}
                                                                        onMouseLeave={() => setHover(0)}
                                                                        className="star"
                                                                        style={{
                                                                          width: "24px",
                                                                          height: "24px",
                                                                          cursor: "pointer",
                                                                          color: "gold",
                                                                        }}
                                                                      />
                                                                    ) : (
                                                                      <BiStar
                                                                        onMouseEnter={() => setHover(ratingValue)}
                                                                        onMouseLeave={() => setHover(0)}
                                                                        className="star"
                                                                        style={{
                                                                          width: "24px",
                                                                          height: "24px",
                                                                          cursor: "pointer",
                                                                          color: "gray",
                                                                        }}
                                                                      />
                                                                    )}
                                                                  </label>
                                                                );
                                                              })}
                                                              {/* <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span> */}
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className='col-12 px-0'>
                                                          <TextArea
                                                            // onChange={onChangeFeedBackMsg}
                                                            value={feedbackMessage}
                                                            labelName={`Your feedback(optional)`}
                                                            rows={'2'}
                                                            onChange={(e) => { setFeedbackMessage(e.target.value) }}
                                                            onBlur={() => { }}
                                                          />
                                                        </div>

                                                        {/* {paymentGatewayFlag && receiverData.amount_after_discount > 0 && !sentRequest[0]?.transactions[0]?.refund_status &&
                                            <div className='col-12 d-flex align-items-center'>
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="refund"
                                                name="refund"
                                                onChange={(e) => { setIsReqRefund(!isReqRefund) }}
                                                value={isReqRefund}
                                                checked={isReqRefund}
                                              />
                                              <span
                                                className='ps-3 font-w600 fs-5 pt-1'
                                                onClick={() => { setIsReqRefund(!isReqRefund) }}
                                              >
                                                {`I want to request a refund`}
                                              </span>
                                            </div>
                                          } */}
                                                      </>
                                                    }
                                                  </div>

                                                  {/* work in progress */}
                                                  <div
                                                    className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered bg-white"
                                                    onClick={() => { setJobStatus(2) }}
                                                    style={{
                                                      border: jobStatus == 2 ? '2px solid orange' : '',
                                                    }}
                                                  >
                                                    <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                      <div className='d-flex'>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                          <div className="pe-4">
                                                            {/* <input
                                                  className="form-check-input"
                                                  style={{ display: 'inline-block' }}
                                                  name="selectJobStatus"
                                                  type="radio"
                                                  value={2}
                                                  onChange={(e) => { setJobStatus(2) }}
                                                  checked={jobStatus == 2}
                                              /> */}
                                                          </div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                          <span className='font-w700 text-black fs-5'>{`Work in Process`}</span>
                                                          <span className=''>{`The work is still ongoing`}</span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-0 text-black mt-4 mb-2">
                                                    <div className="col-12 "
                                                      style={{
                                                        // pointerEvents: jobStatus == 2 ? "none" : "auto",
                                                        // opacity: jobStatus == 2 ? "0.5" : "1",
                                                      }}
                                                    >
                                                      <PrimaryButton
                                                        onClick={(e) => {
                                                          if (jobStatus == 2) {
                                                            // handleCloseChangeJobStatusModal();
                                                            navigate("/dashboard");
                                                            localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                          } else {
                                                            if (jobStatus || jobStatus == 0) {
                                                              handleChangeJobStatusFn(e);
                                                            }
                                                          }
                                                        }}
                                                        buttonName={`SUBMIT`}
                                                        loadingMessage={"Loading..."}
                                                        isLoading={changeJobStatusLoading}
                                                        style={{
                                                          width: "100%",
                                                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                          border: '2px solid rgba(255, 154, 32, 1)',
                                                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                          borderRadius: '4px'
                                                        }}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row my-3">
                                                    <div className="col-12  fs-6 px-0 text-center  ">
                                                      <span className="text-black">{`Need to go back? `}</span>
                                                      <span
                                                        className="pointer font-w600"
                                                        onClick={() => {
                                                          window.location.reload()
                                                        }}
                                                        style={{
                                                          color: '#7c9abd'
                                                        }}
                                                      >
                                                        {`Rejoin call`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </> :
                                      <>
                                        {estimationCallTabs == 1 ?
                                          <>
                                            <div className="row mx-0">
                                              <div className="col-12 px-0">

                                                <div className="col-12 ">
                                                  <div className="mx-0 row">
                                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                                      <span className="">
                                                        <i className="bi bi-x-lg cursor-pointer"
                                                          onClick={(e) => {
                                                            navigate("/dashboard");
                                                            localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                          }}
                                                        ></i>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div className="mx-0 row mb-4">

                                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                                      <span>{formatTime(localStorage.getItem("timeUsedInSeconds"))}</span>
                                                    </div>
                                                  </div>
                                                  <div className="mx-0 row mb-4">
                                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black mt-3">
                                                      <span>Rate your Experience</span>
                                                    </div>
                                                  </div>
                                                  <div className="mx-0 row mb-4">
                                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                                      {/* May be create a separate component for this rating */}

                                                      <div
                                                        style={{ display: "flex", justifyContent: "center" }}>
                                                        {[...Array(5)].map((star, i) => {
                                                          const ratingValue = i + 1;
                                                          return (
                                                            <label key={i}>
                                                              <input
                                                                type="radio"
                                                                name="rating"
                                                                value={ratingValue}
                                                                onClick={(e) => {
                                                                  setRating(ratingValue == 0 ? 1 : ratingValue);

                                                                }}
                                                                style={{ display: "none" }}
                                                              />
                                                              {ratingValue <= (hover || rating) ? (
                                                                <BsStarFill
                                                                  onMouseEnter={() => setHover(ratingValue)}
                                                                  onMouseLeave={() => setHover(0)}
                                                                  className="star"
                                                                  style={{
                                                                    width: "24px",
                                                                    height: "24px",
                                                                    cursor: "pointer",
                                                                    color: "gold",
                                                                  }}
                                                                />
                                                              ) : (
                                                                <BiStar
                                                                  onMouseEnter={() => setHover(ratingValue)}
                                                                  onMouseLeave={() => setHover(0)}
                                                                  className="star"
                                                                  style={{
                                                                    width: "24px",
                                                                    height: "24px",
                                                                    cursor: "pointer",
                                                                    color: "gray",
                                                                  }}
                                                                />
                                                              )}
                                                            </label>
                                                          );
                                                        })}
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-0 mt-4">
                                                    <div className="col-12 px-0 text-center fs-6 d-flex justify-content-center">
                                                      <span>{`Please share your feedback with us. We'd love to hear from you about your work experience.`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mt-4">
                                                    <div className="col-12  fs-7 px-0 text-center ">
                                                      <TextArea
                                                        labelName={"You feedback"}
                                                        placeholder={"Message..."}
                                                        onChange={(e) => {
                                                          setFeedbackMessage(e.target.value);
                                                        }}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row mx-0 mt-2">
                                                    <div className="col-12 px-0 fs-7  mb-2">
                                                      <PrimaryButton
                                                        onClick={submitFeedback}
                                                        loadingMessage={"SUBMITTING..."}
                                                        isLoading={isLoading}
                                                        buttonName={"SEND FEEDBACK"}
                                                        type={"submit"}
                                                        style={{
                                                          width: "100%",
                                                          background: "green",
                                                          border: "1px solid green",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row my-3">
                                                    <div className="col-12  fs-6 px-0 text-center  ">
                                                      <span className="text-black">{`Need to go back? `}</span>
                                                      <span
                                                        className="pointer font-w600"
                                                        onClick={() => {
                                                          window.location.reload()
                                                        }}
                                                        style={{
                                                          color: '#7c9abd'
                                                        }}
                                                      >
                                                        {`Rejoin call`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>



                                                {/* This is neccessary code as for now flow has changed*/}
                                                {false && <>
                                                  <div className="mx-0 row mb-3">
                                                    <div className="col-12 d-flex align-items-center justify-content-between px-0 text-black">
                                                      <span>
                                                        {false && <span
                                                          onClick={() => {
                                                          }}
                                                          className="cursor-pointer py-2 text-black fs- font-w600 overlay-action-btn rounded-3">
                                                          <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                                        </span>}
                                                      </span>

                                                      <span className="">
                                                        <i className="bi bi-x-lg cursor-pointer fs-4"
                                                          onClick={(e) => {
                                                            navigate("/dashboard");
                                                            localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                          }}
                                                        ></i>
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w600 fs-4 px-0 text-center text-black ">
                                                      <span>{formatTime(localStorage.getItem("timeUsedInSeconds"))}</span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w600 fs-4 px-0 text-center text-black ">
                                                      <span>{`Pro Check Info`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w500 px-0 ">
                                                      <span>{`Expected cost for a ${serviceDetailsObj?.product_type_chr ? serviceDetailsObj?.product_type_chr : ''} Replacement for a:`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w600 px-0  text-black">
                                                      <span>{`Summary: `}</span>
                                                    </div>
                                                    <div className="col-12 font-w500 px-0">
                                                      <span>{serviceSummaryMetaData?.recognized_image_summary ?
                                                        serviceSummaryMetaData?.recognized_image_summary :
                                                        `Unable to ptovide image summary.`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w600 px-0  text-black ">
                                                      <span>{`Diagnosis: `}</span>
                                                    </div>
                                                    <div className="col-12 font-w500  px-0">
                                                      <span>{serviceSummaryMetaData?.pro_check_info?.pro_diagnosis ?
                                                        serviceSummaryMetaData?.pro_check_info?.pro_diagnosis :
                                                        `No Diagnosis available.`}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w600 px-0 text-black mb-1">
                                                      <span>{`Estimated Cost Range: `}</span>
                                                    </div>
                                                    <div className="col-12 font-w500 fs-6 px-0 text-center">
                                                      <div className='d-flex align-items-center justify-content-between'>
                                                        <div
                                                          className='p-2 d-flex align-items-center justify-content-center'
                                                          style={{
                                                            // border: '3px solid orange',
                                                            borderRadius: '4px',
                                                            width: '45%',
                                                          }}
                                                        >
                                                          <span className='font-w600' style={{ color: '#1faff5' }}>
                                                            {
                                                              USDollar.format(parseFloat(serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min?.toFixed(2) || 0))
                                                            }
                                                          </span>
                                                        </div>

                                                        <div
                                                          className='p-2 d-flex align-items-center justify-content-center text-black'
                                                        >
                                                          <span className="font-w600"> {`to`}</span>
                                                        </div>

                                                        <div
                                                          className='p-2 d-flex align-items-center justify-content-center'
                                                          style={{
                                                            // border: '3px solid orange',
                                                            borderRadius: '4px',
                                                            width: '45%',
                                                          }}
                                                        >
                                                          <span className='font-w600' style={{ color: '#1faff5' }}>
                                                            {
                                                              USDollar.format(parseFloat(serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max?.toFixed(2)) || 0)
                                                            }
                                                          </span>
                                                        </div>

                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12 font-w600 px-0  text-black mb-2">
                                                      <span>{`Solution Recommendation: `}</span>
                                                    </div>

                                                    <div
                                                      className="col-12 d-flex flex-column justify-content-center align-items-center rounded-2 text-white p-3 mb-2"
                                                      onClick={(e) => {
                                                        setProRecommendedSolution(1);
                                                        // setEstimationCallTabs(2);

                                                        if (serviceDetailsObj?.project_id_lng) {
                                                          localStorage.setItem("projectId", serviceDetailsObj?.project_id_lng);
                                                          localStorage.setItem("DIYprojectStep", 3);
                                                          navigate('/DIYproject');
                                                          localStorage.setItem("isDisconnectedCall", JSON.stringify(true));
                                                        } else {
                                                          handleCreateDIYProject();
                                                          handleUpdateTicketSummary(e, 1);
                                                        }
                                                      }}
                                                      style={{
                                                        background: proRecommendedSolution == 1 ? 'rgb(253, 101, 22)' : 'rgb(79, 93, 116)',
                                                        fontWeight: proRecommendedSolution == 1 ? 'bold' : '',
                                                      }}
                                                    >
                                                      <span className="fs-5 text-center">{`DIY with Chilll Toolbox`}</span>
                                                      <span className="text-center">{`Free`}</span>
                                                    </div>

                                                    <div
                                                      className="col-12 d-flex flex-column justify-content-center align-items-center rounded-2 text-white p-3 mb-2"
                                                      onClick={(e) => {
                                                        setProRecommendedSolution(2);
                                                        // setEstimationCallTabs(3);
                                                        handleUpdateTicketSummary(e, 2);
                                                      }}
                                                      style={{
                                                        background: proRecommendedSolution == 2 ? 'rgb(253, 101, 22)' : 'rgb(79, 93, 116)',
                                                        fontWeight: proRecommendedSolution == 2 ? 'bold' : '',
                                                      }}
                                                    >
                                                      <span className="fs-5 text-center">{`DIY with Remote Pro`}</span>
                                                      <span className="text-center">
                                                        {`${USDollar.format(
                                                          parseFloat(callChargeAmount?.toFixed(2))
                                                        )} for ${callDurationTimeLimit} minutes`}
                                                      </span>
                                                    </div>

                                                    <div
                                                      className="col-12 d-flex flex-column justify-content-center align-items-center rounded-2 text-white p-3 mb-2"
                                                      onClick={() => {
                                                        setProRecommendedSolution(3);
                                                        setEstimationCallTabs(4);
                                                      }}
                                                      style={{
                                                        background: proRecommendedSolution == 3 ? 'rgb(253, 101, 22)' : 'rgb(79, 93, 116)',
                                                        fontWeight: proRecommendedSolution == 3 ? 'bold' : '',
                                                      }}
                                                    >
                                                      <span className="fs-5 text-center">{`Get Local Pro`}</span>
                                                      <span className="text-center">{`Free Matching on your terms`}</span>
                                                    </div>


                                                  </div>

                                                  <div className="mx-0 row mb-2">
                                                    <div className="col-12  fs-6 px-0 text-center  ">
                                                      <span className="text-black">{`Need to go back? `}</span>
                                                      <span
                                                        className="pointer font-w600"
                                                        onClick={() => {
                                                          window.location.reload()
                                                        }}
                                                        style={{
                                                          color: '#7c9abd'
                                                        }}
                                                      >
                                                        {`Rejoin call`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </>}
                                              </div>
                                            </div>
                                          </> :
                                          // Project creating success message
                                          estimationCallTabs == 2 ?
                                            <>
                                              <div className="row mx-0">
                                                <div className="col-12 px-0 py-4">
                                                  <>
                                                    <div className='mx-0 row text-black mb-4'>
                                                      <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                        <img src={logo} alt="" style={{ maxWidth: '125px' }} />
                                                      </div>
                                                    </div>

                                                    <div className='mx-0 row text-black mb-4'>
                                                      <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                        <span>
                                                          {responceMsg || 'Create Project Successfully.'}
                                                        </span>
                                                      </div>

                                                    </div>

                                                    <div className='row mx-0'>
                                                      <div className='col-12 px-0'>
                                                        <PrimaryButton
                                                          onClick={() => {
                                                            // setEstimationCallTabs(1)
                                                            localStorage.setItem("isDisconnectedCall", JSON.stringify(true));

                                                            if (proRecommendedSolution == 1) {
                                                              if (projectId) {
                                                                localStorage.setItem("projectId", projectId);
                                                                localStorage.setItem("DIYprojectStep", 3);
                                                                navigate('/DIYproject');
                                                              } else {
                                                                navigate("/dashboard");
                                                              }
                                                            }

                                                          }}
                                                          buttonName={"OK"}
                                                          type="submit"
                                                          loadingMessage="SUBMITTING..."
                                                          isLoading={false}
                                                          style={{
                                                            width: "100%",
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            border: '1px solid rgba(255, 154, 32, 1)',
                                                            fontWeight: '600',
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </>
                                                </div>
                                              </div>
                                            </> :
                                            // DIY with Remote Pro / Get Local Pro success message
                                            estimationCallTabs == 3 ?
                                              <>
                                                <div className="row mx-0">
                                                  <div className="col-12 px-0 py-4">
                                                    <>
                                                      <div className='mx-0 row text-black mb-4'>
                                                        <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                          <img src={logo} alt="" style={{ maxWidth: '125px' }} />
                                                        </div>
                                                      </div>

                                                      <div className='row mx-0 mt-4'>
                                                        <div className='font-w600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                          <span className=' text-center text-black'>
                                                            {"We've submitted your project proposal to our local vetted pro network"}
                                                          </span>
                                                        </div>
                                                      </div>

                                                      <div className='row mx-0 mt-4'>
                                                        <div className='font-w600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                          <span className=' text-center text-black'>
                                                            {"We'll be in touch when the job is accepted"}
                                                          </span>
                                                        </div>
                                                      </div>

                                                      <div className='row mx-0 mt-4'>
                                                        <div className='font-w600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                          <span className=' text-center text-black'>
                                                            {"Thanks for choosing Chilll"}
                                                          </span>
                                                        </div>
                                                      </div>

                                                      <div className='row mx-0 mt-4'>
                                                        <div className='col-12 px-0'>
                                                          <PrimaryButton
                                                            onClick={() => {
                                                              // setEstimationCallTabs(1);
                                                              localStorage.setItem("isDisconnectedCall", JSON.stringify(true));
                                                              navigate('/serviceRequestDetails');
                                                            }}
                                                            buttonName={"OK"}
                                                            type="submit"
                                                            loadingMessage="SUBMITTING..."
                                                            isLoading={false}
                                                            style={{
                                                              width: "100%",
                                                              background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                              boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                              border: '1px solid rgba(255, 154, 32, 1)',
                                                              fontWeight: '600',
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </>
                                                  </div>
                                                </div>
                                              </> :
                                              // Get Local Pro action modal
                                              estimationCallTabs == 4 ?
                                                <>
                                                  <div className="row mx-0">
                                                    <div className="col-12 px-0 py-4">
                                                      <>
                                                        <div className="mx-0 row mb-2">
                                                          <div className="col-12 d-flex align-items-center justify-content-between px-0 text-black">
                                                            <span>
                                                              {<span
                                                                onClick={() => {
                                                                  setEstimationCallTabs(1);
                                                                }}
                                                                className="cursor-pointer py-2 text-black fs- font-w600 overlay-action-btn rounded-3">
                                                                <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                                              </span>}
                                                            </span>

                                                            <span className="">
                                                              {/* <i className="bi bi-x-lg cursor-pointer fs-4"
                                                          onClick={(e) => {
                                                            navigate("/dashboard");
                                                            localStorage.setItem("isDisconnectedCall", JSON.stringify(true))
                                                          }}
                                                        ></i> */}
                                                            </span>
                                                          </div>
                                                        </div>

                                                        <div className='row mx-0'>
                                                          <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                                            <span className=''>
                                                              {"I need a Local Pro"}
                                                            </span>
                                                          </div>
                                                        </div>

                                                        <div className='row mx-0 mt-3'>
                                                          <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                            <span className=' text-center text-black'>
                                                              {"We've flipped the local Pro Process script"}
                                                            </span>
                                                          </div>
                                                        </div>

                                                        <div className='row mx-0 mt-3'>
                                                          <div className='font-w600 text-black col-12 px-0 d-flex align-items-center fs-5 '>
                                                            <div className='row mx-0 w-100'>
                                                              <div className='d-flex align-items-center col-md-6 mb-2'>
                                                                <span className='me-2 text-center' style={{ color: '#27AE60', fontSize: '20px' }}>
                                                                  <i class="bi bi-check-lg"></i>
                                                                </span>
                                                                <span className=' text-center'>
                                                                  {"Project Info Collected"}
                                                                </span>
                                                              </div>

                                                              <div className='d-flex align-items-center col-md-6 mb-2'>
                                                                <span className='me-2 text-center' style={{ color: '#27AE60', fontSize: '20px' }}>
                                                                  <i class="bi bi-check-lg"></i>
                                                                </span>
                                                                <span className=' text-center'>
                                                                  {"Cost Range Determined"}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <form className='w-100'
                                                          onSubmit={(e) => {
                                                            // handleUpdateTicketSummary(e);
                                                          }}
                                                        >

                                                          <div className="row mt-3">

                                                            <div className='col-12 px-0 '>
                                                              <div className='d-flex align-items-center justify-content-between'>

                                                                <div className="" style={{ width: '45%', }}>
                                                                  <InputField
                                                                    labelName={"Low ($)"}
                                                                    placeholderName={"Low ($)"}
                                                                    value={`${customerEstimatedCostMin}`}
                                                                    onChange={(e) => { handleCustomerEstimatedCostMin(e) }}
                                                                    onBlur={() => { }}
                                                                    errorOccured={false}
                                                                    errorMeesage={"Please add Labor"}
                                                                  />
                                                                </div>

                                                                <div
                                                                  className='p-2 d-flex align-items-center justify-content-center'
                                                                >
                                                                  <span className='font-w600 text-black fs-6 mb-3'> {`to`}</span>
                                                                </div>

                                                                <div className="" style={{ width: '45%', }}>
                                                                  <InputField
                                                                    labelName={"High ($)"}
                                                                    placeholderName={"High ($)"}
                                                                    value={`${customerEstimatedCostMax}`}
                                                                    onChange={(e) => { handleCustomerEstimatedCostMax(e) }}
                                                                    onBlur={() => { }}
                                                                    errorOccured={false}
                                                                    errorMeesage={"Please add Labor"}
                                                                  />
                                                                </div>

                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className='row mx-0 '>
                                                            <div className='font-w600 text-black col-12 px-0 d-flex align-items-center fs-5 '>
                                                              <div className='d-flex align-items-center mb-2'>
                                                                <span className='me-2 text-center' style={{ color: '#27AE60', fontSize: '20px' }}>
                                                                  <i class="bi bi-check-lg"></i>
                                                                </span>
                                                                <span className=' text-center'>
                                                                  {"When do you want it done?"}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className='row mx-0 '>
                                                            <div className='row'>
                                                              <div className='col-12 px-0' >
                                                                <div className="d-flex align-items-center">
                                                                  <input
                                                                    className="form-check-input"
                                                                    style={{ display: 'inline-block' }}
                                                                    name="selectRole"
                                                                    type="radio"
                                                                    value={`1`}
                                                                    onChange={(e) => { setLocalProSectionDateTime(e.target.value); }}
                                                                    checked={localProSectionDateTime == "1"}
                                                                  />
                                                                  <span
                                                                    className='ps-2 pt-1 text-black fs-5 font-w600'
                                                                  >
                                                                    {`As soon as possible`}
                                                                  </span>
                                                                </div>

                                                              </div>
                                                            </div>

                                                            <div className='row mt-1'>
                                                              <div className='col-12 px-0' >
                                                                <div className="d-flex align-items-center mt-2">
                                                                  <input
                                                                    className="form-check-input mb-3"
                                                                    style={{ display: 'inline-block', minWidth: '18px' }}
                                                                    name="selectRole"
                                                                    type="radio"
                                                                    value={`2`}
                                                                    onChange={(e) => { setLocalProSectionDateTime(e.target.value); }}
                                                                    checked={localProSectionDateTime == "2"}
                                                                  />
                                                                  <span
                                                                    className='ps-2 pt-1 w-100'
                                                                  >
                                                                    <div className='col-12 px-0 '>
                                                                      <div className='d-flex align-items-center justify-content-between'>


                                                                        <div className="" style={{ width: '45%', }}>

                                                                          <InputField
                                                                            type="date"
                                                                            labelName={"Date"}
                                                                            placeholder={"Date"}
                                                                            value={currentDateLocalPro}
                                                                            onChange={(e) => setCurrentDateLocalPro(e.target.value)}
                                                                            errorOccured={false}
                                                                            errorMeesage={"Please enter date"}
                                                                            onBlur={() => { }}
                                                                          />
                                                                        </div>

                                                                        <div
                                                                          className='p-2 px-1 d-flex align-items-center justify-content-center'
                                                                        >
                                                                          <span className='font-w600 text-black fs-6 mb-3'> {`near`}</span>
                                                                        </div>

                                                                        <div className="" style={{ width: '45%', }}>
                                                                          <InputField
                                                                            type="time"
                                                                            labelName={"Time"}
                                                                            placeholder={"Date and time"}
                                                                            value={currentTimeLocalPro}
                                                                            onChange={(e) => {
                                                                              setCurrentTimeLocalPro(e.target.value)
                                                                            }}
                                                                            errorOccured={false}
                                                                            errorMeesage={""}
                                                                            onBlur={() => { }}
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </span>
                                                                </div>

                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className='row mx-0 mt-3'>
                                                            <div className='row'>
                                                              <div className='col-12 px-0' >
                                                                <div className="d-flex align-items-center">
                                                                  <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="refund"
                                                                    name="refund"
                                                                    onChange={(e) => {
                                                                      setTermsAndConditions(!termsAndConditions);
                                                                      setTermsAndConditionsErr(false)
                                                                    }}
                                                                    value={termsAndConditions}
                                                                    checked={termsAndConditions}
                                                                  />
                                                                  <span
                                                                    className='ps-3 pt-1 text-black fs-5'
                                                                  >
                                                                    {`Agree to`}
                                                                    <strong className='text-hovered cursor-pointer ps-1' >
                                                                      <a
                                                                        className="terms-condition-link"
                                                                        href="https://chilll.com/chilll-terms-conditions/"
                                                                        target="_blank"
                                                                        rel="noreferrer">
                                                                        {"Terms and Conditions "}
                                                                      </a>
                                                                    </strong>
                                                                  </span>
                                                                </div>
                                                                {termsAndConditionsErr &&
                                                                  <div className='mt-2 text-danger fs-12'>
                                                                    <span>{`Please accept the Terms & Conditions`}</span>
                                                                  </div>
                                                                }
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className='row mx-0 mt-3'>
                                                            <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                              <PrimaryButton
                                                                buttonName={"Submit to Chilll Network"}
                                                                onClick={(e) => {
                                                                  handleUpdateTicketSummary(e, 3);
                                                                  // setEstimationCallTabs(3);
                                                                }}
                                                                loadingMessage={"Loading..."}
                                                                isLoading={updateTicketSummaryLoading}
                                                                style={{
                                                                  width: '100%',
                                                                  background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                  border: '2px solid rgba(255, 154, 32, 1)',
                                                                  boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                }}
                                                              />
                                                            </div>
                                                          </div>
                                                        </form>
                                                      </>
                                                    </div>
                                                  </div>
                                                </> :
                                                <></>
                                        }
                                      </>
                                    }
                                  </>
                              }


                            </div>

                          </>
                        }
                      </> :
                      <div className="col-12 px-0 h-100 d-flex justify-content-between flex-column">
                        <div>
                          <div className="mx-0 row">
                            <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                              <span className="">
                                <i className="bi bi-x-lg cursor-pointer" onClick={(e) => { navigate("/dashboard"); }}></i>
                              </span>
                            </div>
                          </div>

                          <div className="mx-0 row mb-4">
                            <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                              <span>{formatTime(localStorage.getItem("timeUsedInSeconds"))}</span>
                            </div>
                          </div>

                          <div className="mx-0 row mb-4">
                            <div className="col-12 font-w600 fs-4 px-0 text-center text-black ">
                              <span>{`Thank you for choosing Chilll. We hope you had a great experience.`}</span>
                            </div>
                          </div>
                          <div className="mx-0 row mb-4">
                            <div className="col-12 fs-6 px-0 text-center">
                              {`In order to save the call details, like notes, messages, images, and product-related data. Please sign up to save this information for later use.`}
                            </div>
                          </div>
                        </div>

                        <div className="row mx-0 mt-2">
                          <div className="col-12 px-0 fs-7 mb-2">
                            <PrimaryButton
                              onClick={handleSignUpGuest}
                              loadingMessage={"Submitting..."}
                              isLoading={false}
                              buttonName={"SIGN UP"}
                              type={"submit"}
                              style={{
                                width: "100%",
                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                border: '2px solid rgba(255, 154, 32, 1)',
                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mx-0 mt-2">
                          <div className="col-12 px-0 fs-7 mb-2">
                            <PrimaryButton
                              onClick={(e) => {
                                // window.open(appLink, '_blank');
                                openInApp(e);
                              }}
                              loadingMessage={"Loading..."}
                              isLoading={appLinkLoading}
                              buttonName={"SIGN UP ON APP"}
                              type={"submit"}
                              style={{
                                width: "100%",
                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                border: '2px solid rgba(255, 154, 32, 1)',
                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                              }}
                            />
                          </div>
                        </div>

                        <div className="mx-0 row my-3">
                          <div className="col-12  fs-6 px-0 text-center  ">
                            <span className="text-black">{`Need to go back? `}</span>
                            <span
                              className="pointer font-w600"
                              onClick={() => {
                                window.location.reload()
                              }}
                              style={{
                                color: '#7c9abd'
                              }}
                            >
                              {`Rejoin call`}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </> :
              <>
                <div className='row mx-0 px-4 py-3'>
                  <div className='col-12 px-0'>

                    <div className='row mx-0'>
                      <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                        <span onClick={() => handleCloseShareService()} className='cursor-pointer'>
                          <i className="bi bi-x-lg"></i>
                        </span>
                      </div>
                    </div>

                    <div className='row mx-0'>
                      <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                        <span className=''>
                          {"Share service details"}
                        </span>
                      </div>
                    </div>

                    <div className='row mx-0 mt-3'>
                      <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                        <span className=' text-center'>
                          {"Share the information gathered in this call"}
                        </span>
                      </div>
                    </div>

                    <form className='w-100' onSubmit={(e) => handleShareService(e)}>
                      <EmailPhoneCombine
                        inputValue={emailPhoneValue}
                        handleChangeCode={handleDropdownValue}
                        handleInputValue={handleEmailPhone}
                        isEnteringNumber={isPhone}
                        setIsEnteringNumber={setIsPhone}
                        errorOccured={isEmailPhoneVal}
                        errorMessage={validEmail_OR_MobileNumberText}
                        handleOnBlur={handleEmailPhoneBlur}
                        defaultCodeValue={codeValue}
                      />

                      <div className='row mx-0 mt-1'>
                        <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                          <PrimaryButton
                            buttonName={"SEND"}
                            onClick={(e) => handleShareService(e)}
                            loadingMessage={"SENDING..."}
                            isLoading={shareLoading}
                            style={{
                              background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                              border: '2px solid rgba(255, 154, 32, 1)',
                              boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                            }}
                          />
                        </div>
                      </div>
                    </form>

                  </div>
                </div>
              </>

            }

          </Modal>
        </div>

      }
      {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
    </>
  );
};

export default CallRating;
